import React, { FunctionComponent } from 'react'
import { Box, SxStyleProp } from 'theme-ui'

import theme from '../../gatsby-plugin-theme-ui'
const { colors } = theme

import {
  IMakerConfigItem,
  // IMakerConfigOption
} from '../../types'
import {
  SANTA,
  ELF,
  BEARD,
  FART,
  FRECKLES,
  STUBBLE,
  T_SHIRT,
  HEADPHONES,
  GLASSES,
  COFFEE,
  LAPTOP_SCREEN,
  LAPTOP_STICKERS,
} from '../../const'

interface IMakerBumProps {
  /** The config passed from bum-bum-maker page */
  config: IMakerConfigItem[]
  /** Theme UI JSX pragma */
  sx?: SxStyleProp
}

const getCheckedProperties = (config: IMakerConfigItem[]) => {
  return config.reduce((items, item) => {
    items.push(item.options.filter((option) => option.checked).map((option) => option.value)[0])
    return items
  }, [])
}

const properties = (property: string, tone: number) => {
  const config = {
    [LAPTOP_STICKERS]: (
      <g id="latop-stickers">
        <g>
          <path
            fill={colors.shadowAccent}
            d="M304,355.1l-38,5.7c-2.9,0.4-3.2,4.5-0.4,5.3l95.9,28.1c0.4,0.1,0.8,0.1,1.3,0.1l155.2-27.6
			c3.1-0.6,3-5.1-0.2-5.4l-89.2-9.7c-0.1,0-0.2,0-0.4,0l-124,3.4C304.3,355.1,304.1,355.1,304,355.1z"
          />
          <path
            d="M374.2,387.5c-0.7,0-1.5-0.1-2.2-0.3l-57.2-16.2c-2.4-0.7-4.3-2.4-5.2-4.6l-2.4-5.8c-1.1-2.8-0.6-5.9,1.3-8.2
			c1.5-1.8,3.7-2.8,6-2.8c0.2,0,0.3,0,0.5,0l52.1-5.8l16.9-80.7c0.6-3.1,3-5.5,6.1-6.1l6.5-1.4c0.2,0,0.4-0.1,0.6-0.1l125.4-17.5
			c0.4-0.1,0.7-0.1,1.1-0.1c2.3,0,4.5,1,6,2.7c1.8,2,2.4,4.8,1.7,7.4l-31.2,111.7c-0.8,2.9-3.2,5.1-6.2,5.7L378,386.5
			c0,0-0.1,0-0.1,0.1C376.8,387.2,375.5,387.5,374.2,387.5z"
          />
          <polygon fill="#6B6B6B" points="492.5,357.5 373.8,379.2 398.3,263.3 523.8,245.8 		" />
          <polygon fill="#C6C6C6" points="376.6,350.7 314.8,357.6 371.8,371.8 		" />
          <polygon fill="#A6A6A6" points="374.2,379.5 371.8,371.5 314.5,357.5 316.9,363.3 		" />
          <polygon fill="#A6A6A6" points="374.5,379.3 368.2,377.8 391.8,264.7 398.3,263.3 		" />
          <g>
            <g>
              <path
                fill={colors.gatsbyDefault}
                d="M422.1,280.9c7.7-0.8,14,4.7,14,12.3c0,7.6-6.3,14.6-14,15.5s-14-4.6-14-12.3
					C408.1,288.7,414.3,281.8,422.1,280.9z"
              />
            </g>
            <g>
              <path
                fill={colors.white}
                d="M414.3,303.9c-2.1-1.8-3.2-4.5-3.2-7.2l10.9,9.5C419.2,306.4,416.4,305.7,414.3,303.9z M424.5,305.5
					L411.4,294c1.1-5,5.5-9.2,10.7-9.7c3.7-0.4,6.9,1,8.9,3.5l-1.5,1.5c-1.7-2.1-4.4-3.3-7.4-3c-3.9,0.4-7.2,3.3-8.5,6.9l11.5,10.1
					c2.9-1.3,5.1-4.1,5.8-7.1l-4.8,0.6v-2l7-0.8C433.1,299.1,429.4,303.8,424.5,305.5z"
              />
            </g>
          </g>
          <g>
            <g>
              <polygon
                fill={colors.gatsbyDark}
                points="487.5,265.8 471.1,272.3 466,289.7 477.3,301.1 493.6,295.2 498.8,277.3 				"
              />
              <g>
                <path
                  fill={colors.white}
                  d="M471.2,282.4l1.5-0.6c0.4-0.1,0.7-0.2,0.9,0c0.2,0.1,0.4,0.3,0.5,0.7c0,0.2,0,0.4,0,0.5
						c0,0.2-0.1,0.3-0.3,0.5c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3
						c0,0.2,0,0.4,0,0.5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.2,0.3-0.4,0.4c-0.2,0.1-0.3,0.2-0.6,0.3l-1.7,0.6L471.2,282.4z
						 M472.6,283.6l0.2-0.1c0.3-0.1,0.5-0.3,0.4-0.6c-0.1-0.3-0.2-0.3-0.6-0.2l-0.2,0.1L472.6,283.6z M473,285.2l0.2-0.1
						c0.3-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.2-0.1-0.2-0.2-0.3c-0.1,0-0.3,0-0.6,0.1l-0.2,0.1L473,285.2z"
                />
                <path fill={colors.white} d="M475.7,280.2l1,4.5l-1,0.4l-1-4.5L475.7,280.2z" />
                <path
                  fill={colors.white}
                  d="M478.8,280.9l1-0.4l0.6,2.8l-1,0.4l-0.1-0.3c-0.1,0.3-0.4,0.6-0.7,0.7c-0.2,0.1-0.4,0.1-0.6,0.1
						c-0.2,0-0.3-0.1-0.5-0.1c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.2,0-0.4,0-0.6c0-0.2,0.1-0.4,0.2-0.6
						c0.1-0.2,0.2-0.3,0.4-0.5c0.1-0.1,0.3-0.2,0.5-0.3c0.3-0.1,0.6-0.1,0.9,0L478.8,280.9z M477.9,282.7c0,0.1,0.1,0.2,0.1,0.2
						c0,0.1,0.1,0.1,0.2,0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.2-0.2
						s0.1-0.2,0.1-0.3s0-0.2,0-0.3c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0
						c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.2,0.2c0,0.1-0.1,0.2-0.1,0.2C477.9,282.6,477.9,282.6,477.9,282.7z"
                />
                <path
                  fill={colors.white}
                  d="M482.2,281.7l1.1-0.4l0.2,0.8l-2.8,1l0.9-2.5l-1.1,0.4l-0.2-0.8l2.7-1L482.2,281.7z"
                />
                <path
                  fill={colors.white}
                  d="M483.2,278c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1
						c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2-0.1,0.2
						c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1
						C483.3,278.2,483.3,278.1,483.2,278z M484.5,278.7l0.6,2.8l-1,0.4l-0.6-2.8L484.5,278.7z"
                />
                <path
                  fill={colors.white}
                  d="M485.2,278.5l1-0.4l0.1,0.4c0.1-0.2,0.2-0.4,0.3-0.5c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.1,0.5-0.1
						c0.1,0,0.3,0.1,0.4,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.1,0.4l0.4,1.8l-1,0.4l-0.3-1.4c0-0.1-0.1-0.2-0.1-0.3
						c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3,0.2-0.3,0.3c-0.1,0.1-0.1,0.3,0,0.5l0.3,1.5
						l-1,0.4L485.2,278.5z"
                />
                <path
                  fill={colors.white}
                  d="M491.7,275.9l0.5,2.6c0,0.2,0.1,0.3,0.1,0.4c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.3-0.1,0.4
						c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.4,0-0.5-0.1
						c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.4l1.1-0.4c0.1,0.2,0.3,0.2,0.5,0.1c0.2-0.1,0.3-0.2,0.4-0.4s0.1-0.3,0.1-0.6
						l-0.1-0.3c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.2,0.1
						c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.3,0-0.5-0.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2-0.1-0.4,0-0.6
						s0.1-0.4,0.2-0.6c0.1-0.2,0.2-0.3,0.4-0.5c0.2-0.1,0.3-0.3,0.5-0.3c0.3-0.1,0.6-0.1,0.9,0.1l-0.1-0.3L491.7,275.9z
						 M489.9,278.2c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.2-0.1
						c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.2
						c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.2,0.2s-0.1,0.2-0.1,0.3
						C489.8,278,489.8,278.1,489.9,278.2z"
                />
                <path
                  fill={colors.white}
                  d="M479.8,286.9l-1.2,0.5l0.1,0.7l1.1-0.4l0.2,0.9l-1.1,0.4l0.3,1.6l-1,0.4l-0.9-4.1l2.3-0.9L479.8,286.9z
						"
                />
                <path
                  fill={colors.white}
                  d="M482.5,286.3l1-0.4l0.6,2.8l-1,0.4l-0.1-0.3c-0.1,0.3-0.4,0.6-0.7,0.7c-0.2,0.1-0.4,0.1-0.6,0.1
						c-0.2,0-0.3-0.1-0.5-0.2c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.2-0.3-0.2-0.6c0-0.2,0-0.4,0-0.6c0-0.2,0.1-0.4,0.2-0.6
						c0.1-0.2,0.2-0.3,0.4-0.5c0.1-0.1,0.3-0.2,0.5-0.3c0.3-0.1,0.6-0.1,0.9,0L482.5,286.3z M481.6,288.1c0,0.1,0.1,0.2,0.1,0.2
						c0,0.1,0.1,0.1,0.2,0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.2-0.2
						c0-0.1,0.1-0.2,0.1-0.3s0-0.2,0-0.3c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0
						c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.2,0.2c0,0.1-0.1,0.2-0.1,0.2S481.6,288.1,481.6,288.1z"
                />
                <path
                  fill={colors.white}
                  d="M486.1,285.7c-0.2,0-0.4,0-0.5,0.1c-0.1,0-0.2,0.1-0.2,0.1s-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1
						c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.3,0,0.5,0,0.7,0.1c0.2,0.1,0.3,0.2,0.3,0.5c0,0.2,0,0.3,0,0.5
						c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1,0.1-0.3,0.2-0.5,0.3c-0.4,0.1-0.8,0.2-1.2,0.1l0.2-0.8
						c0.3,0.1,0.6,0.1,0.8,0c0.1,0,0.2-0.1,0.2-0.1c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0
						c-0.1,0-0.1,0-0.2,0c-0.3,0-0.5,0-0.7,0c-0.1-0.1-0.2-0.2-0.3-0.4c0-0.2,0-0.3,0-0.5c0-0.1,0.1-0.3,0.2-0.4
						c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.2,0.5-0.3c0.3-0.1,0.6-0.2,0.9-0.1L486.1,285.7z"
                />
                <path
                  fill={colors.white}
                  d="M488.1,285.1l0.4,2l-1,0.4l-0.4-2l-0.3,0.1l-0.2-0.8l0.3-0.1l-0.2-0.8l1-0.4l0.2,0.8l0.5-0.2l0.2,0.8
						L488.1,285.1z"
                />
              </g>
              <path
                fill={colors.gatsbyLight}
                d="M473,276.6c0,0.2-0.1,0.5-0.3,0.6c-0.2,0.1-0.4,0-0.5-0.3c0-0.2,0.1-0.5,0.3-0.6
					C472.7,276.3,472.9,276.4,473,276.6z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M474.2,274.9c0,0.1-0.1,0.3-0.2,0.3c-0.1,0-0.2,0-0.3-0.1c0-0.1,0.1-0.3,0.2-0.3
					S474.2,274.7,474.2,274.9z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M475.1,277.6c0,0.2-0.1,0.5-0.3,0.6c-0.2,0.1-0.4,0-0.5-0.3c0-0.2,0.1-0.5,0.3-0.6
					S475.1,277.4,475.1,277.6z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M473.7,279.8c0,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0-0.3-0.2c0-0.1,0.1-0.3,0.2-0.4
					C473.5,279.6,473.7,279.7,473.7,279.8z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M477.1,275.9c0,0.1-0.1,0.3-0.2,0.4s-0.3,0-0.3-0.2s0.1-0.3,0.2-0.4
					C476.9,275.7,477.1,275.8,477.1,275.9z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M487.7,270.5c-0.2,0-0.4-0.2-0.3-0.5c0.1-0.2,0.3-0.4,0.5-0.4c0.2,0,0.4,0.2,0.3,0.5
					C488.2,270.4,487.9,270.5,487.7,270.5z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M487.8,268.9c-0.1,0-0.2-0.1-0.2-0.3c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.1,0.2,0.3
					C488.1,268.8,488,268.9,487.8,268.9z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M487.5,274.9c-0.2,0-0.4-0.2-0.3-0.5c0.1-0.2,0.3-0.4,0.5-0.4c0.2,0,0.4,0.2,0.3,0.5
					S487.7,274.9,487.5,274.9z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M481.2,271.6c-0.1,0-0.2-0.1-0.2-0.3s0.2-0.3,0.3-0.3c0.1,0,0.2,0.1,0.2,0.3
					C481.5,271.5,481.3,271.6,481.2,271.6z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M482.6,273.9c-0.1,0-0.2-0.1-0.2-0.3s0.2-0.3,0.3-0.3c0.1,0,0.2,0.1,0.2,0.3
					C482.9,273.8,482.7,273.9,482.6,273.9z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M469.4,288.3c-0.1,0.2-0.3,0.4-0.5,0.3c-0.2-0.1-0.3-0.3-0.2-0.5c0.1-0.2,0.3-0.4,0.5-0.3
					C469.3,287.9,469.4,288.1,469.4,288.3z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M473.4,287.9c0,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2-0.2-0.1-0.3c0-0.1,0.2-0.2,0.3-0.2
					C473.4,287.7,473.5,287.8,473.4,287.9z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M475.8,295.6c-0.1,0.2-0.3,0.4-0.5,0.3c-0.2-0.1-0.3-0.3-0.2-0.5c0.1-0.2,0.3-0.4,0.5-0.3
					C475.8,295.1,475.9,295.4,475.8,295.6z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M473,290.6c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2-0.2-0.1-0.3s0.2-0.2,0.3-0.2S473,290.4,473,290.6z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M474.5,292c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2-0.2-0.1-0.3s0.2-0.2,0.3-0.2
					C474.5,291.7,474.6,291.8,474.5,292z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M482.9,296.6c0.2,0.1,0.2,0.4,0,0.6c-0.2,0.2-0.4,0.3-0.6,0.1c-0.2-0.1-0.2-0.4,0-0.6
					C482.5,296.5,482.8,296.5,482.9,296.6z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M484.5,292.4c0.1,0.1,0.1,0.2,0,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1-0.1-0.1-0.2,0-0.3
					C484.3,292.4,484.4,292.3,484.5,292.4z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M492.5,291.7c0.2,0.1,0.2,0.4,0,0.6c-0.2,0.2-0.4,0.3-0.6,0.1c-0.2-0.1-0.2-0.4,0-0.6
					C492,291.6,492.3,291.6,492.5,291.7z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M486.7,293.5c0.1,0.1,0.1,0.3,0,0.4s-0.3,0.2-0.4,0.1c-0.1-0.1-0.1-0.3,0-0.4
					C486.4,293.4,486.6,293.4,486.7,293.5z"
              />
              <path
                fill={colors.gatsbyLight}
                d="M488.6,292.2c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.3,0.2-0.4,0.1c-0.1-0.1-0.1-0.3,0-0.4
					C488.4,292.2,488.5,292.1,488.6,292.2z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                fill={colors.white}
                d="M461.5,328.2c0-0.7-0.2-1.4-0.6-1.9c-0.6-0.6-1.4-0.9-2.4-0.8c-1.4,0.2-2.9,0.9-4.1,1.8
					c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.5,0.2-0.8,0.3l-0.1,0.1c-0.4,0.2-0.7,0.4-1,0.6c-0.1,0-0.2,0.1-0.3,0.2l-1.4,0.7
					c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.4,0.2l-1.4,0.8c-0.3,0.1-0.5,0.3-0.7,0.5c-0.2,0.1-0.5,0.2-0.8,0.3l-1.3,0.7
					c0.3-0.8,0.4-1.6,0.2-2.3l-0.3-1.1l0.8-0.4c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.3-0.1,0.4-0.2l1.4-0.7c0.4-0.2,0.8-0.5,1.1-0.8
					c0,0,0,0,0.1,0c0.7-0.1,1.4-0.4,2.2-0.8c2.6-1.3,4.2-3.6,4.3-6.1c0-0.3,0-0.6-0.1-0.9c0-0.2-0.1-0.4-0.1-0.6l0-0.1
					c-0.2-0.7-0.5-1.2-0.9-1.7c-0.5-0.5-1-0.9-1.7-1.1c-0.7-0.2-1.4-0.3-2.2-0.1c-1,0.2-2,0.6-3,1.2c-0.8-0.3-1.8-0.3-2.8,0.3
					l-0.2,0.1c-0.4-0.1-0.9-0.2-1.5-0.1c-1.1,0.1-2.3,0.7-3.3,1.7c-0.4,0.4-0.8,0.9-1,1.4c-0.2,0.5-0.4,0.9-0.5,1.4
					c-0.2,0.1-0.4,0.3-0.6,0.5c-0.2,0.2-0.4,0.3-0.5,0.5c-0.1,0-0.1,0-0.2,0c-0.7-1.3-2.4-1.7-4-0.8l-1.4,0.7
					c-1.5,0.8-2.5,2.4-2.5,3.8c-0.4,0.2-0.8,0.5-1.1,0.8c-0.2,0.1-0.4,0.1-0.6,0.2l-1.6,0.8c-0.4,0.2-0.7,0.4-1,0.7
					c-0.4,0.1-0.7,0.2-1.1,0.4l-0.9,0.5c-0.3,0.2-0.7,0.4-1,0.7c-0.3,0.1-0.7,0.2-1,0.4l-1.6,0.8c-0.4,0.2-0.7,0.4-1,0.7
					c-0.4,0.1-0.8,0.2-1.1,0.4l-1.7,0.9c-0.4,0.2-0.7,0.4-1,0.7c-0.4,0.1-0.8,0.2-1.1,0.4l-1.7,0.9c-0.2,0.1-0.3,0.2-0.5,0.3
					c-0.8,0.3-1.7,0.7-2.4,1.3c-0.8,0.2-1.6,0.6-2.3,1.1c-0.1,0.1-0.3,0.1-0.4,0.2l-1.4,0.8c-1.8,1-2.9,3.1-2.4,4.8l1.1,3.8
					c0.4,1.6,2.1,2.2,3.7,1.5l1.1,3.7c0.4,1.4,1.7,2,3.2,1.6l0.2,0.6c0.2,0.6,0.5,1,0.9,1.3l0.3,1.1c0.5,1.7,2.4,2.2,4.2,1.3
					l1.4-0.8c0.2-0.1,0.4-0.3,0.6-0.4c0.2-0.1,0.4-0.2,0.6-0.3l1.4-0.8c0.2-0.1,0.5-0.3,0.7-0.5c0.2-0.1,0.5-0.2,0.7-0.3l1.4-0.8
					c0.3-0.2,0.6-0.4,0.9-0.6c0.6-0.1,1.2-0.3,1.8-0.7c0.4-0.2,0.8-0.5,1.1-0.7c0,0,0.1,0,0.1,0l1.4-0.8c0.1-0.1,0.2-0.1,0.3-0.2
					c0.1-0.1,0.2-0.1,0.4-0.2l1.4-0.8c0.2-0.1,0.5-0.3,0.7-0.5c0.2-0.1,0.5-0.2,0.7-0.3l1.4-0.8c0.1,0,0.1-0.1,0.1-0.1
					c0.1,0.1,0.2,0.2,0.3,0.3c0.9,0.6,2.1,0.6,3.3-0.1l1.6-0.9c1.2-0.7,2.2-1.9,2.5-3.1l0.2-0.7c0.1,0,0.2,0,0.3,0
					c0.7-0.1,1.4-0.4,2.2-0.8c0.7-0.4,1.4-0.9,2-1.4c0.1-0.1,0.3-0.3,0.4-0.4c0.9-0.1,1.8-0.4,2.8-0.9c0.7-0.4,1.4-0.8,1.9-1.3
					c0.3-0.1,0.6-0.2,0.9-0.3l1.4-0.8c0.4-0.2,0.8-0.5,1.2-0.9c0.8-0.1,1.5-0.4,2.2-0.8c0.6-0.3,1.2-0.7,1.7-1.1
					c0.6-0.5,1.1-1,1.4-1.6c0.5-0.7,0.8-1.4,0.9-2.2c0.1-0.8,0.1-1.5-0.1-2.1C462,328.9,461.8,328.5,461.5,328.2z"
              />
              <g>
                <path
                  fill={colors.gatsbyDefault}
                  d="M406.2,341.3l1.4-0.8l0.1,0.5c0.3-0.6,0.7-1,1.2-1.2c0.6-0.3,1.1-0.3,1.6,0c0.2-0.6,0.6-1.1,1.2-1.4
						c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0c0.2,0,0.3,0.1,0.4,0.3c0.1,0.1,0.2,0.3,0.3,0.6l0.7,2.4l-1.4,0.8l-0.5-1.9
						c-0.1-0.2-0.1-0.3-0.2-0.4s-0.1-0.2-0.2-0.2c-0.1,0-0.2-0.1-0.2,0c-0.1,0-0.2,0-0.2,0.1c-0.5,0.2-0.6,0.7-0.4,1.3l0.5,1.9
						l-1.4,0.8l-0.5-1.9c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2-0.1-0.2,0c-0.1,0-0.2,0.1-0.3,0.1
						c-0.1,0-0.2,0.1-0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.3,0.1,0.5l0.5,1.9l-1.4,0.8L406.2,341.3z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M416.1,339.8l-2.9-2.2l1.7-0.9l1.7,1.4l0.5-2.5l1.7-0.9l-1.6,7.4l-1.6,0.9L416.1,339.8z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M422.4,332.7l1.6,1.5l0.4-2.5l0.9-0.5l1.6,1.5l0.4-2.6l1.6-0.8l-1,4.8l-1,0.5l-1.6-1.5l-0.4,2.6l-1,0.5
						l-3.2-2.6L422.4,332.7z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M430.9,330.7c0.2,0.6,0.5,0.7,1.1,0.4c0.3-0.2,0.5-0.4,0.6-0.7l1.4-0.7c0,1-0.6,1.8-1.7,2.4
						c-0.3,0.2-0.7,0.3-1,0.4c-0.3,0.1-0.6,0-0.9,0c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.3-0.4-0.4-0.7c-0.1-0.3-0.1-0.6-0.1-0.9
						c0-0.3,0.1-0.6,0.3-0.9c0.1-0.3,0.3-0.5,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.6c0.3-0.2,0.7-0.3,1-0.3c0.3,0,0.6,0,0.8,0
						c0.2,0.1,0.5,0.2,0.6,0.4c0.2,0.2,0.3,0.5,0.4,0.8l0,0.1L430.9,330.7z M432.4,329.1c-0.1-0.2-0.2-0.3-0.4-0.3
						c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.4-0.1,0.6L432.4,329.1z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M434.6,323.7l0.8,2.7c0.2-0.5,0.6-0.9,1.1-1.1c0.3-0.2,0.6-0.2,0.9-0.3c0.3,0,0.5,0,0.8,0.1
						c0.2,0.1,0.4,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.7c0.1,0.3,0.1,0.6,0.1,0.9c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.8
						c-0.2,0.2-0.5,0.4-0.8,0.6c-0.5,0.3-1,0.3-1.4,0.1l0.1,0.4l-1.4,0.8l-1.8-6L434.6,323.7z M437.7,327c0-0.1-0.1-0.2-0.2-0.3
						c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.3s-0.2,0.2-0.2,0.3
						c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.3,0,0.4c0,0.1,0.1,0.2,0.2,0.3s0.2,0.1,0.3,0.2c0.1,0,0.2,0,0.4,0c0.1,0,0.3-0.1,0.4-0.1
						c0.1-0.1,0.2-0.2,0.3-0.3s0.2-0.2,0.2-0.3s0.1-0.2,0.1-0.4C437.7,327.2,437.7,327.1,437.7,327z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M442.1,323.6c-0.3,0-0.6,0.1-0.8,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2-0.1,0.3
						c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.4-0.1c0.4-0.1,0.8-0.2,1-0.1c0.3,0.1,0.4,0.3,0.5,0.6
						c0.1,0.2,0.1,0.4,0,0.7c0,0.2-0.1,0.4-0.3,0.6c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.5,0.4-0.8,0.5c-0.6,0.3-1.1,0.4-1.8,0.4
						l0.3-1.2c0.5,0,0.9,0,1.3-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0
						c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0.1-0.3,0.1c-0.5,0.1-0.8,0.2-1,0.1c-0.2-0.1-0.4-0.2-0.5-0.5c-0.1-0.2-0.1-0.4,0-0.6
						c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.3-0.4,0.5-0.6c0.2-0.2,0.4-0.3,0.7-0.5c0.5-0.2,0.9-0.4,1.4-0.4L442.1,323.6z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M442.4,320.7c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.2-0.3
						c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3
						c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.1
						c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.2-0.1C442.5,320.9,442.4,320.8,442.4,320.7z M444.4,321.3l1.1,3.7l-1.4,0.7l-1.1-3.7
						L444.4,321.3z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M447,321.2l0.8,2.6l-1.4,0.7l-0.8-2.6l-0.5,0.2l-0.3-1.1l0.5-0.2l-0.3-1.1l1.4-0.7l0.3,1.1l0.8-0.4
						l0.3,1.1L447,321.2z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M449.7,320.9c0.2,0.6,0.5,0.7,1.1,0.4c0.3-0.2,0.5-0.4,0.6-0.7l1.4-0.7c0,1-0.6,1.8-1.7,2.3
						c-0.3,0.2-0.7,0.3-1,0.3c-0.3,0.1-0.6,0-0.9,0c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.3-0.4-0.4-0.7c-0.1-0.3-0.1-0.6-0.1-0.9
						c0-0.3,0.1-0.6,0.3-0.9c0.1-0.3,0.3-0.5,0.6-0.8c0.3-0.2,0.6-0.4,0.9-0.6c0.3-0.2,0.7-0.3,1-0.3c0.3,0,0.6,0,0.8,0
						c0.2,0.1,0.5,0.2,0.6,0.4c0.2,0.2,0.3,0.5,0.4,0.8l0,0.1L449.7,320.9z M451.2,319.3c-0.1-0.2-0.2-0.3-0.4-0.3
						c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.4-0.1,0.6L451.2,319.3z"
                />
              </g>
              <g>
                <path
                  fill={colors.gatsbyDefault}
                  d="M410.5,345.1c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.3s0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2
						c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3
						c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2s-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0
						c-0.1,0-0.2-0.1-0.2-0.1C410.6,345.3,410.6,345.2,410.5,345.1z M412.5,345.8l1.1,3.8l-1.4,0.8l-1.1-3.8L412.5,345.8z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M416.2,344.9c-0.3,0-0.6,0.1-0.8,0.2c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.1,0.2-0.1,0.3
						c0,0,0,0.1,0.1,0.1s0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.4-0.1c0.4-0.1,0.8-0.2,1-0.1c0.3,0.1,0.4,0.3,0.5,0.6
						c0.1,0.2,0.1,0.4,0,0.7c0,0.2-0.1,0.4-0.3,0.7c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.5,0.4-0.8,0.5c-0.6,0.3-1.1,0.4-1.8,0.4
						l0.3-1.2c0.5,0,0.9,0,1.3-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0
						c-0.1,0-0.1,0-0.2,0s-0.2,0.1-0.3,0.1c-0.5,0.2-0.8,0.2-1,0.1c-0.2-0.1-0.4-0.2-0.5-0.5c-0.1-0.2-0.1-0.4,0-0.6
						c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.3-0.4,0.5-0.6c0.2-0.2,0.4-0.3,0.7-0.5c0.5-0.2,0.9-0.4,1.4-0.5L416.2,344.9z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M421.3,342.4l0.8,2.6l-1.4,0.8l-0.8-2.6l-0.5,0.3l-0.3-1.1l0.5-0.3l-0.2-0.6c-0.1-0.3-0.1-0.6-0.1-0.8
						c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.3-0.3,0.4-0.5c0.2-0.1,0.3-0.3,0.5-0.4c0.1-0.1,0.2-0.1,0.3-0.1
						c0.1,0,0.2-0.1,0.3-0.1l0.3,1.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.2
						c0,0.1-0.1,0.2,0,0.3c0,0.1,0,0.2,0.1,0.4l0.1,0.5l1-0.5l0.3,1.1L421.3,342.4z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M425.4,338.9l1.4-0.8l1.1,3.7l-1.4,0.8l-0.1-0.4c-0.2,0.5-0.6,0.9-1.1,1.2c-0.3,0.2-0.6,0.3-0.9,0.3
						s-0.5,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.3-0.4-0.4-0.7c-0.1-0.3-0.1-0.5-0.1-0.8c0-0.3,0.1-0.6,0.2-0.9
						c0.1-0.3,0.3-0.5,0.5-0.8c0.2-0.2,0.5-0.4,0.8-0.6c0.5-0.3,1-0.3,1.4-0.2L425.4,338.9z M424.2,341.7c0,0.1,0.1,0.2,0.2,0.3
						c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.3-0.1,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3s0.2-0.2,0.2-0.3
						c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.3,0-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2,0-0.3,0
						c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.4
						C424.1,341.5,424.1,341.6,424.2,341.7z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M430.6,337.3c-0.3,0-0.6,0.1-0.8,0.2c-0.1,0.1-0.2,0.2-0.3,0.2s-0.1,0.2-0.1,0.3c0,0,0,0.1,0.1,0.1
						c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.4-0.1c0.4-0.1,0.8-0.2,1-0.1c0.3,0.1,0.4,0.3,0.5,0.6
						c0.1,0.2,0.1,0.4,0,0.7c0,0.2-0.1,0.4-0.3,0.6c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.5,0.4-0.8,0.5c-0.6,0.3-1.1,0.4-1.8,0.4
						l0.3-1.2c0.5,0,0.9,0,1.3-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0
						c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0.1-0.3,0.1c-0.5,0.2-0.8,0.2-1,0.1c-0.2-0.1-0.4-0.2-0.5-0.5c-0.1-0.2-0.1-0.4,0-0.6
						c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.3-0.4,0.5-0.6c0.2-0.2,0.4-0.3,0.7-0.5c0.5-0.2,0.9-0.4,1.4-0.5L430.6,337.3z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M433.4,336l0.8,2.6l-1.4,0.8l-0.8-2.6l-0.5,0.3l-0.3-1.1l0.5-0.3l-0.3-1.1l1.4-0.8l0.3,1.1l0.8-0.4
						l0.3,1.1L433.4,336z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M436.2,335.6c0.2,0.6,0.5,0.7,1.1,0.4c0.3-0.2,0.5-0.4,0.6-0.7l1.4-0.7c0,1-0.6,1.8-1.7,2.4
						c-0.3,0.2-0.7,0.3-1,0.4s-0.6,0.1-0.9,0c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.3-0.4-0.4-0.7c-0.1-0.3-0.1-0.6-0.1-0.9
						s0.1-0.6,0.3-0.9c0.1-0.3,0.3-0.5,0.6-0.8c0.3-0.2,0.6-0.5,0.9-0.6c0.3-0.2,0.7-0.3,1-0.3c0.3-0.1,0.6,0,0.8,0
						c0.2,0.1,0.5,0.2,0.6,0.4c0.2,0.2,0.3,0.5,0.4,0.8l0,0.1L436.2,335.6z M437.6,334c-0.1-0.2-0.2-0.3-0.4-0.3
						c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.4-0.1,0.6L437.6,334z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M439.1,331.7l1.4-0.8l0.2,0.6c0.1-0.3,0.2-0.6,0.4-0.8c0.2-0.2,0.4-0.4,0.7-0.6c0,0,0.1,0,0.1-0.1
						c0,0,0.1,0,0.2-0.1l0.4,1.2c-0.2,0-0.4,0.1-0.7,0.2c-0.3,0.2-0.6,0.4-0.7,0.7c-0.1,0.3-0.1,0.6,0,0.9l0.5,1.6l-1.4,0.8
						L439.1,331.7z"
                />
              </g>
              <g>
                <path
                  fill={colors.gatsbyDefault}
                  d="M417.4,351.5l0.8,2.6l-1.4,0.8l-0.8-2.6l-0.5,0.3l-0.3-1.1l0.5-0.3l-0.3-1.1l1.4-0.8l0.3,1.1l0.8-0.4
						l0.3,1.1L417.4,351.5z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M417.7,347.4l1.4-0.8l0.8,2.8c0.1-0.3,0.3-0.6,0.5-0.8c0.2-0.2,0.4-0.3,0.7-0.5
						c0.5-0.3,0.9-0.4,1.3-0.2c0.3,0.1,0.6,0.4,0.7,0.8l0.7,2.4l-1.4,0.8l-0.6-1.9c-0.1-0.2-0.1-0.3-0.2-0.4
						c-0.1-0.1-0.1-0.2-0.2-0.2c-0.2,0-0.3,0-0.5,0.1c-0.2,0.1-0.4,0.3-0.5,0.5c-0.1,0.2-0.1,0.4,0,0.7l0.6,2l-1.4,0.8L417.7,347.4z
						"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M426.5,345.4l1.4-0.8l1.1,3.7l-1.4,0.8l-0.1-0.4c-0.2,0.5-0.6,0.9-1.1,1.2c-0.3,0.2-0.6,0.3-0.9,0.3
						c-0.3,0-0.5,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.3-0.4-0.4-0.7c-0.1-0.3-0.1-0.5-0.1-0.8c0-0.3,0.1-0.6,0.2-0.9
						c0.1-0.3,0.3-0.5,0.5-0.8c0.2-0.2,0.5-0.4,0.8-0.6c0.5-0.3,1-0.3,1.4-0.2L426.5,345.4z M425.3,348.2c0,0.1,0.1,0.2,0.2,0.3
						c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.3-0.1,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.2-0.3
						c0.1-0.1,0.1-0.2,0.1-0.4s0-0.3,0-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2,0-0.3,0
						c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.4
						C425.2,348,425.2,348.1,425.3,348.2z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M428.7,344.3l1.4-0.8l0.1,0.5c0.1-0.3,0.3-0.6,0.5-0.8c0.2-0.2,0.4-0.3,0.7-0.5
						c0.3-0.2,0.5-0.2,0.8-0.3c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.3,0.2,0.5l0.7,2.4l-1.4,0.8l-0.6-1.9
						c-0.1-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0.1-0.4,0.3-0.5,0.5
						c-0.1,0.2-0.1,0.4,0,0.7l0.6,2l-1.4,0.8L428.7,344.3z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M438.5,342.7l-2.9-2.1l1.7-0.9l1.7,1.3l0.5-2.5l1.7-0.9l-1.6,7.3l-1.6,0.9L438.5,342.7z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M441.5,339.6c-0.1-0.3-0.1-0.6,0-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0.2-0.3,0.4-0.6,0.7-0.8
						c0.3-0.3,0.6-0.5,0.9-0.7c0.3-0.2,0.7-0.3,1-0.4s0.6-0.1,0.9,0c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.3,0.4,0.4,0.7
						c0.1,0.3,0.1,0.6,0.1,0.9c-0.1,0.3-0.2,0.6-0.3,0.9c-0.2,0.3-0.4,0.6-0.7,0.8c-0.3,0.3-0.6,0.5-0.9,0.7c-0.4,0.2-0.7,0.3-1,0.4
						c-0.3,0.1-0.6,0.1-0.9,0c-0.3-0.1-0.5-0.2-0.7-0.4C441.7,340.1,441.6,339.9,441.5,339.6z M443,338.8c0,0.1,0.1,0.2,0.2,0.3
						c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.3-0.1,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.2-0.3
						c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.3,0-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2,0-0.3,0
						c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.2,0.3s-0.1,0.2-0.1,0.4C442.9,338.6,443,338.7,443,338.8
						z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M447.8,334.2l0.6,2.1c0.1,0.5,0.4,0.6,0.9,0.3c0.5-0.3,0.7-0.6,0.5-1.1l-0.6-2.1l1.4-0.8l0.7,2.3
						c0.1,0.5,0.1,1-0.2,1.4c-0.3,0.4-0.8,0.8-1.5,1.2c-0.7,0.4-1.3,0.5-1.7,0.5c-0.4-0.1-0.7-0.3-0.9-0.8l-0.7-2.3L447.8,334.2z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M451.4,332.3l1.4-0.8l0.2,0.6c0.1-0.3,0.2-0.6,0.4-0.8c0.2-0.2,0.4-0.4,0.7-0.6c0,0,0.1,0,0.1-0.1
						c0,0,0.1,0,0.2-0.1l0.4,1.2c-0.2,0-0.4,0.1-0.7,0.2c-0.3,0.2-0.6,0.4-0.7,0.7c-0.1,0.3-0.1,0.6,0,0.9l0.5,1.6l-1.4,0.8
						L451.4,332.3z"
                />
                <path
                  fill={colors.gatsbyDefault}
                  d="M457.8,330c-0.3,0-0.6,0.1-0.8,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2-0.1,0.3
						c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.4-0.1c0.4-0.1,0.8-0.2,1-0.1c0.3,0.1,0.4,0.3,0.5,0.5
						c0.1,0.2,0.1,0.4,0,0.6c0,0.2-0.1,0.4-0.3,0.6c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.5,0.4-0.8,0.5c-0.6,0.3-1.1,0.4-1.8,0.4
						l0.3-1.2c0.5,0,0.9,0,1.3-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0
						c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0.1-0.3,0.1c-0.5,0.2-0.8,0.2-1,0.1c-0.2-0.1-0.4-0.2-0.5-0.5c-0.1-0.2-0.1-0.4,0-0.6
						s0.1-0.4,0.2-0.6c0.1-0.2,0.3-0.4,0.5-0.6c0.2-0.2,0.4-0.3,0.7-0.5c0.5-0.2,0.9-0.4,1.4-0.4L457.8,330z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    ),
    [LAPTOP_SCREEN]: (
      <g id={LAPTOP_SCREEN}>
        <g>
          <ellipse fill={colors.shadowAccent} cx="425.4" cy="354.5" rx="112.3" ry="13.6" />
          <g>
            <g>
              <path
                d="M329.6,359.2c-6.6,0-12-5.4-12-12s5.4-12,12-12h36.7l26.2-91.7c1.4-4.9,5.9-8.3,11-8.3c0.6,0,1.2,0,1.8,0.1h126.5
              c0.6-0.1,1.2-0.1,1.8-0.1c1.1,0,2.1,0.1,3.1,0.4c6.1,1.7,9.6,8.1,7.9,14.1l-28.3,99c-0.1,0.4-0.2,0.7-0.4,1
              c-1.3,5.3-6,9.2-11.6,9.2h-44.6c-0.2,0-0.5,0-0.7,0c-0.2,0-0.4,0-0.7,0H329.6z M496.3,335.3l21.7-75.9H411.7L390,335.3h68.3
              c0.2,0,0.5,0,0.7,0c0.2,0,0.4,0,0.7,0H496.3z"
              />
              <path
                d="M378.9,347.5h122.2c2.6,0,5.4-2.4,6.3-5.4l24.8-89.1c0.9-3-0.5-5.4-3.1-5.4H407c-2.6,0-5.4,2.4-6.3,5.4l-24.8,89.1
              C375,345.1,376.4,347.5,378.9,347.5z"
              />
              <path
                fill="#A6A6A6"
                d="M329.6,343.3h42.7l27.8-97.4c0.5-1.8,2.4-2.9,4.3-2.4c0.1,0,0.1,0.1,0.2,0.1c0.2,0,0.4-0.1,0.6-0.1
              h128.5c0.4,0,0.7,0.1,1,0.2c-0.9,2.6-1.5,5.2-1.8,7.8H405.7l-27.2,95.3c-0.1,0.3-0.2,0.5-0.4,0.8c-0.2,2.1-1.9,3.7-4,3.7h-44.6
              c-2.2,0-4-1.8-4-4C325.6,345,327.4,343.3,329.6,343.3z"
              />
              <path
                fill="#A6A6A6"
                d="M329.6,351.2h128.8c2.1,0,3.8-1.7,3.8-3.8v-0.4c0-2.1-1.7-3.8-3.8-3.8H329.6c-2.1,0-3.8,1.7-3.8,3.8v0.4
              C325.8,349.5,327.5,351.2,329.6,351.2z"
              />
              <path
                fill="#6B6B6B"
                d="M459.6,343.3h42.7l27.8-97.4c0.5-1.8,2.4-2.9,4.3-2.4c1.8,0.5,2.9,2.4,2.4,4.3l-28.3,99
              c-0.1,0.3-0.2,0.5-0.4,0.8c-0.2,2.1-1.9,3.7-4,3.7h-44.6c-2.2,0-4-1.8-4-4C455.6,345,457.4,343.3,459.6,343.3z"
              />
              <g>
                <g>
                  <path
                    fill={colors.primary}
                    d="M433.1,271.1h39.6c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9h-39.6c-1,0-2.2,0.8-2.5,1.9l0,0
                  C431.5,270.3,432.1,271.1,433.1,271.1z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.secondary}
                    d="M484.8,280.8h18.9c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9h-18.9c-1,0-2.2,0.8-2.5,1.9l0,0
                  C483.2,280,483.8,280.8,484.8,280.8z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.secondary}
                    d="M420.3,280.8h18.9c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9h-18.9c-1,0-2.2,0.8-2.5,1.9l0,0
                  C418.7,280,419.3,280.8,420.3,280.8z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.secondary}
                    d="M447.1,280.8h31.1c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9h-31.1c-1,0-2.2,0.8-2.5,1.9l0,0
                  C445.6,280,446.1,280.8,447.1,280.8z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.primary}
                    d="M410.9,290.9h70.2c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9h-70.2c-1,0-2.2,0.8-2.5,1.9l0,0
                  C409.4,290.1,409.9,290.9,410.9,290.9z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.secondary}
                    d="M489.1,290.9h11.5c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9h-11.5c-1,0-2.2,0.8-2.5,1.9l0,0
                  C487.5,290.1,488,290.9,489.1,290.9z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.secondary}
                    d="M423.6,301.9h70.2c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9h-70.2c-1,0-2.2,0.8-2.5,1.9l0,0
                  C422,301,422.6,301.9,423.6,301.9z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.secondary}
                    d="M453.8,311.9h36.1c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9h-36.1c-1,0-2.2,0.8-2.5,1.9l0,0
                  C452.2,311,452.7,311.9,453.8,311.9z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.secondary}
                    d="M409.7,311.9h36.1c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9H411c-1,0-2.2,0.8-2.5,1.9l0,0
                  C408.1,311,408.7,311.9,409.7,311.9z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.secondary}
                    d="M475.5,322.8h11.2c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9h-11.2c-1,0-2.2,0.8-2.5,1.9l0,0
                  C474,321.9,474.5,322.8,475.5,322.8z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.primary}
                    d="M397.9,322.8h70.2c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9h-70.2c-1,0-2.2,0.8-2.5,1.9l0,0
                  C396.3,321.9,396.9,322.8,397.9,322.8z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.secondary}
                    d="M413.1,332.8h70.2c1,0,2.2-0.8,2.5-1.9l0,0c0.4-1-0.2-1.9-1.2-1.9h-70.2c-1,0-2.2,0.8-2.5,1.9l0,0
                  C411.5,332,412,332.8,413.1,332.8z"
                  />
                </g>
                <g>
                  <path
                    fill={colors.secondary}
                    d="M507.8,267.5l-5.9,2.9c-0.2,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1
                  c-0.1-0.1-0.1-0.2-0.2-0.4c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.4-0.2
                  l4.3-2.1c-0.1-0.1-1-0.8-2.8-2.1c-0.1-0.1-0.2-0.2-0.2-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.4
                  c0.1-0.1,0.2-0.3,0.4-0.5c0.2-0.2,0.3-0.3,0.5-0.4c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2
                  c0.5,0.4,1.8,1.4,3.9,2.9c0.3,0.2,0.3,0.4,0.2,0.8C508.4,267.1,508.2,267.4,507.8,267.5z"
                  />
                  <path
                    fill={colors.secondary}
                    d="M494.1,263.1c0-0.3,0-0.5,0-0.6c0.1-0.2,0.4-0.5,0.8-0.7c0.3-0.1,0.5-0.2,0.7-0.2c0.1,0,0.2,0,0.2,0
                  c0.1,0,0.1,0.1,0.1,0.1s0,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2l1,7.7c0,0.3,0,0.5-0.1,0.6c0,0.1-0.1,0.2-0.2,0.3
                  c-0.1,0.1-0.3,0.2-0.6,0.3c-0.3,0.1-0.5,0.2-0.7,0.2c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0-0.3
                  L494.1,263.1z"
                  />
                  <path
                    fill={colors.secondary}
                    d="M483.3,265.9l5.9-2.9c0.2-0.1,0.3-0.1,0.4-0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0.1
                  c0.1,0.1,0.1,0.2,0.2,0.4c0,0.2,0.1,0.3,0,0.5c0,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.4,0.2
                  l-4.3,2.1l2.9,2.1c0.1,0.1,0.2,0.2,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2-0.1,0.4c-0.1,0.1-0.2,0.3-0.4,0.5
                  c-0.2,0.2-0.3,0.3-0.5,0.4c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.2l-3.9-2.9
                  c-0.2-0.1-0.3-0.4-0.2-0.8C482.7,266.3,483,266.1,483.3,265.9z"
                  />
                </g>
              </g>
              <circle cx="498.9" cy="347.2" r="1.9" />
              <circle cx="492.8" cy="347.2" r="1.9" />
              <rect
                x="479.8"
                y="346.2"
                transform="matrix(-1 -4.477231e-11 4.477231e-11 -1 967.5411 695.0086)"
                width="8"
                height="2.7"
              />
              <rect
                x="468.4"
                y="346.2"
                transform="matrix(-1 -4.477231e-11 4.477231e-11 -1 944.7138 695.0086)"
                width="8"
                height="2.7"
              />
            </g>
            <g>
              <path d="M485.6,227.2c-1.2-1.5,11.6-14.6,13.9-11.7C501.9,218.5,486.8,228.7,485.6,227.2z" />
            </g>
            <g>
              <path d="M472.2,226.2c-1.9-0.2-2-15.5,1.7-15C477.6,211.7,474.1,226.4,472.2,226.2z" />
            </g>
            <g>
              <path d="M459,227.1c-1.5,1.1-12.8-10.4-9.8-12.7C452.2,212.1,460.5,226,459,227.1z" />
            </g>
          </g>
        </g>
      </g>
    ),
    [COFFEE]: (
      <g id={COFFEE}>
        <ellipse fill={colors.shadowAccent} cx="412.4" cy="332" rx="52.9" ry="10.6" />
        <path
          d="M450.8,325.2c-0.7,0-1.4,0-2.1-0.1c-12.7-1.5-21.1-15.4-19.3-31.6c1.8-15.4,11.8-26.6,23.8-26.6c0.7,0,1.4,0,2.1,0.1
					c12.7,1.5,21.1,15.4,19.3,31.6c-0.8,7.1-3.6,13.7-7.8,18.6C462.5,322.4,456.8,325.2,450.8,325.2z M453.3,284.9
					c-1.4,0-5.1,3.6-5.9,10.6c-0.4,3.3,0,6.6,1.2,9c0.8,1.9,1.8,2.6,2.3,2.7c0,0,0,0,0,0c0.5,0,1.5-0.6,2.5-1.7
					c1.8-2.1,3.1-5.4,3.5-8.9c0.4-3.3,0-6.6-1.2-9C454.8,285.7,453.8,284.9,453.3,284.9L453.3,284.9z"
        />
        <path
          fill={colors.primary}
          d="M450.8,320.2c4.4,0,8.9-2.2,12.3-6.2c3.5-4.1,5.9-9.7,6.6-15.9c1.5-13.5-5-25-14.9-26.1
					c-9.9-1.1-18.8,8.6-20.4,22c-1.5,13.5,5,25,14.9,26.1C449.8,320.2,450.3,320.2,450.8,320.2z M453.3,279.9c0.2,0,0.4,0,0.6,0
					c5.2,0.6,8.8,8.5,7.8,17.2c-0.5,4.5-2.2,8.7-4.7,11.6c-1.2,1.4-3.7,3.8-6.8,3.4c-5.2-0.6-8.8-8.5-7.8-17.2
					C443.4,286.5,448.3,279.9,453.3,279.9z"
        />
        <path
          d="M416.6,337.4c-11.5,0-23.5-1.9-32.2-5c-1.8-0.7-3.1-2.3-3.3-4.2l-6.1-61.4c-0.1-1.4,0.3-2.8,1.3-3.9
				c0.9-1,2.3-1.6,3.7-1.6h69.8c1.4,0,2.8,0.6,3.7,1.7c0.9,1.1,1.4,2.5,1.3,3.9c-0.2,2.2-5.7,54-6.9,61.3c-0.2,1.5-1.2,2.9-2.6,3.6
				C436.6,336.4,424.9,337.4,416.6,337.4C416.6,337.4,416.6,337.4,416.6,337.4z"
        />
        <path
          fill={colors.highlight}
          d="M386,327.7c14.9,5.3,42.7,7.2,56.8-0.4c1.1-7.2,6.9-61,6.9-61h-69.8L386,327.7z"
        />
        <path
          fill={colors.primary}
          d="M381.8,285.7c13,20,35.3,34.4,61.5,38.3c1.8-13.9,6.4-57.6,6.4-57.6h-69.8L381.8,285.7z"
        />
        <path
          d="M414.8,275.9c-9.5,0-18.5-0.5-25.3-1.4c-7.4-1-14.6-2.4-14.6-8.2s7.2-7.2,14.6-8.2c6.8-0.9,15.8-1.4,25.3-1.4
				s18.5,0.5,25.3,1.4c7.4,1,14.6,2.4,14.6,8.2s-7.2,7.2-14.6,8.2C433.4,275.4,424.4,275.9,414.8,275.9z"
        />
        <ellipse fill={colors.primary} cx="414.8" cy="266.3" rx="34.9" ry="4.6" />
        <ellipse cx="414.8" cy="268.8" rx="29.3" ry="2.1" />
        <path fill={colors.white} d="M424.5,282.6l-0.8,27.5l16-1.1c0,0,1.9-21,2.3-27.1L424.5,282.6z" />
        <polygon fill={colors.white} points="424.2,315.7 423.4,325 437.7,323.4 439.2,314.6 			" />
        <g opacity="0.5">
          <path
            fill={colors.white}
            d="M430.5,269.1c0,0-4.6-14.1,5.7-21.7c10.3-7.6,15.6,0.8,22.5-5s3.8-11.1,3.8-11.1s-14.9-2.7-8.4-14.5
				c6.5-11.8,24.4-13.3,30.5-8c6.1,5.3,1.9,9.9,1.9,9.9s14.1,2.3,8,10.3c-6.1,8-24.6,6.7-24.6,6.7s-2.3,17-13.7,16.2
				c-10-0.7-18.1-0.4-20.7,5.3c-2.7,5.7-0.8,12.2-0.8,12.2L430.5,269.1z"
          />
        </g>
        <path
          d="M467.7,217.6c0.9-0.9,1.9-1.1,2.4-1.1c0.5,0,0.7-0.1,0.3-0.4c-0.3-0.3-1.3-0.6-2.6-0.1c-1.2,0.5-2.7,1.6-3.3,3.8
						c-0.5,2.3,0.8,4.9,3,6.3c1.1,0.7,2.4,1.3,3.9,1.4c1.4,0.2,2.8,0,4.2-0.3c1.4-0.3,2.7-0.8,4-1.4c1.3-0.6,2.7-1.2,4-2.2
						c1.3-0.9,2.6-2.1,3.6-3.6c1-1.5,1.5-3.6,1.3-5.5c-0.4-3.9-3.1-7.1-6.4-8.7c-3.3-1.6-6.9-1.8-10.2-1.5c-3.4,0.3-6.6,1.2-9.5,2.6
						c-2.9,1.4-5.6,3.4-7.5,5.8c-1.9,2.5-3,5.5-3,8.3c0,1.4,0.2,2.8,0.7,4c0.2,0.6,0.5,1.2,0.8,1.7c0.4,0.6,0.8,1,1.2,1.4
						c1.8,1.6,3.7,2.3,5.3,2.7c1.7,0.4,3.1,0.4,4.1,0.2c1-0.2,1.5-0.6,1.6-0.8c0.1-0.2-0.1-0.3-0.6-0.3c-0.5,0-1.3-0.1-2.4-0.3
						c-1.1-0.2-2.5-0.7-3.9-1.5c-0.7-0.4-1.4-0.9-2.1-1.5c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.2-0.2-0.3-0.4-0.5
						c-0.2-0.3-0.4-0.7-0.6-1.1c-0.7-1.7-0.7-3.9,0-6.1c0.7-2.1,2.2-4.2,4.2-5.9c2-1.7,4.6-3,7.4-3.8c2.7-0.8,5.7-1.2,8.6-1.1
						c2.9,0.2,5.6,1.1,7.4,2.9c0.9,0.9,1.6,2,1.9,3.2c0.3,1.2,0.3,2.4-0.2,3.5c-0.9,2.2-3.1,3.9-5.3,5c-2.3,1.2-4.5,2.1-6.6,2.3
						c-1,0.1-2,0-2.8-0.3c-0.9-0.3-1.6-0.7-2.2-1.3c-1.2-1.1-1.5-2.5-1.3-3.5C466.8,218.6,467.4,217.9,467.7,217.6z"
        />
        <path
          d="M497.1,223.2c-0.2-0.9-0.7-1.7-1.2-2.3c-2.1-2.5-4.9-3.3-7-3.4c-2.2-0.1-3.9,0.7-4.5,1.5c-0.6,0.8-0.4,1.1,0,1
					c0.5,0,1.3-0.3,2.7-0.2c1.3,0.1,3.3,0.6,4.8,1.8c0.8,0.6,1.5,1.4,1.7,2.1c0.2,0.8,0.2,1.3-0.5,2.3c-0.3,0.5-0.8,1-1.2,1.5
					c-0.4,0.5-0.9,0.9-1.4,1.4c-1,0.9-2.1,1.6-3.3,2.3c-2.4,1.3-4.9,2.1-7.2,2.6c-4.7,0.9-8.5,0.8-9.5,1c-0.3,0.1-0.5,0.1-0.7,0.2
					c-0.7-0.2-1.6,0.2-1.5,1c0.2,3.8-2,7.5-4.5,10.3c-2.3,2.5-5.4,4.6-8.8,5c-4.2,0.5-8.2-1.2-12.4-0.6c-3.9,0.6-6.5,3.2-8.1,6.7
					c-1.7,4-2,8.5-0.4,12.6c0.6,1.6,3.3,1,2.7-0.7c-1.2-3.6-1-7.6,0.7-11.1c0.8-1.7,1.9-3.3,3.7-4c1.7-0.7,3.6-0.7,5.3-0.5
					c4.1,0.4,8,1.4,12,0c3.3-1.2,6.2-3.5,8.4-6.2c2.5-3.1,4.5-7.1,3.8-11.1c0.4,0.1,0.8,0.2,1.2,0.3c1.5,0.3,3.6,0.5,6.1,0.4
					c2.5-0.1,5.4-0.5,8.2-1.5c2.9-1,5.8-2.7,8-5c0.6-0.6,1.1-1.2,1.6-1.8c0.5-0.7,1-1.5,1.3-2.4
					C497.4,225.2,497.4,224.1,497.1,223.2z"
        />
        <path
          d="M463.1,233.7c-0.1-0.9-0.3-1.4-0.4-1.7c-0.2-0.3-0.3-0.3-0.4-0.1c-0.3,0.4-0.5,1.6-1.1,3.2c-0.7,1.6-1.9,3.7-4.1,5.2
						c-1.1,0.8-2.3,1.4-3.7,1.7c-1.4,0.3-3,0.4-4.8,0.3c-1.8,0-3.7-0.1-5.8,0.1c-2.1,0.2-4.3,0.9-6.1,1.9c-1.9,1.1-3.5,2.5-4.7,4.1
						c-1.2,1.7-2.1,3.5-2.6,5.3c-1,3.6-0.8,7-0.4,9.6c0.4,2.7,1,4.7,1.5,5.9c1.1,2.5,1.2,0.5,1.1-3.9c0-2.2-0.1-5,0.4-7.9
						c0.5-2.9,1.7-6,4.1-8.2c1.2-1.1,2.6-2,4.2-2.6c1.6-0.6,3.2-0.8,5-0.9c1.8-0.1,3.7,0,5.5-0.1c1.9-0.1,3.8-0.5,5.4-1.3
						c3.3-1.6,5.2-4.2,6.1-6.3C463.1,236.1,463.2,234.4,463.1,233.7z"
        />

        <path
          fill={colors.shadowAccent}
          d="M314.4,344.4l-52.6,6.3c-6.5,0.8-7.6,9.9-1.3,12.1l55.9,19.8c7.5,2.7,15.5,3.5,23.4,2.6l50.6-6.2
				c6.7-0.9,7.4-10.2,1-12.2L317,344.7C316.1,344.4,315.3,344.3,314.4,344.4z"
        />
        <path
          fill="#C6C6C6"
          d="M319.8,339.1l-52.6,6.3c-6.5,0.8-7.6,9.9-1.3,12.1l55.9,19.8c7.5,2.7,15.5,3.5,23.4,2.6l50.6-6.2
				c6.7-0.9,7.4-10.2,1-12.2l-74.3-22.1C321.5,339.1,320.6,339,319.8,339.1z"
        />
        <path
          fill="#6B6B6B"
          d="M396.6,361.5l-53.9,6.8c-6.4,0.9-13,0.2-19.1-2l-57.9-20.5c-5.2,1.8-5.6,9.7,0.1,11.7l56.1,19.8
				c7.4,2.6,15.3,3.5,23,2.5l50.8-6.2C402.3,372.7,403.1,363.4,396.6,361.5z"
        />
        <path
          fill="#A6A6A6"
          d="M333.4,379.9c3.9,0.4,7.8,0.4,11.7-0.1l50.6-6.2c6.7-0.9,7.4-10.2,1-12.2l-63.4,6.9L333.4,379.9z"
        />
        <polygon points="323.8,373.7 310,369.1 310.2,365.8 323.9,370.4" />
        <polygon points="307.6,368.2 293.9,363.6 294.1,360.3 307.8,364.8" />
        <path
          d="M318.5,340.9l-43.3,4.9c-0.9,0.1-1,1.3-0.2,1.6l56.4,19.1c0.1,0,54-5.2,54-5.2c0.9-0.1,1-1.4,0.1-1.6L318.8,341
				C318.7,340.9,318.6,340.9,318.5,340.9z"
        />
        <g opacity="0.3">
          <path
            fill={colors.shadowBlue}
            d="M314.4,360.8l12.7-17.5l-8.3-2.3c-0.1,0-0.2,0-0.3,0l-22.1,2.5l-6.8,8.9L314.4,360.8z"
          />
          <path fill={colors.shadowBlue} d="M379.8,358.1l-8.9-2.5l-5.4,7.7c4.2-0.4,8.2-0.8,11.4-1.1L379.8,358.1z" />
          <path fill={colors.shadowBlue} d="M359.9,352.5l-12.9-3.6l-12.1,17.4c3.7-0.3,9.8-0.9,16.6-1.6L359.9,352.5z" />
        </g>
      </g>
    ),
    [GLASSES]: (
      <g id={GLASSES}>
        <path
          fill={colors.darkGrey}
          d="M230.5,146.6l-28.6,2.9l1.3,19.2c0,0,23.4,1.1,29.5-3.6C238.9,160.5,230.5,146.6,230.5,146.6z"
        />
        <polygon points="78.9,182.5 8.3,211.1 17.7,228.5 83.5,196.5 		" />
        <g opacity="0.5">
          <path
            fill={colors.shadowBlue}
            d="M75.1,144.5c0,0,7.2,104.8,65.9,102.9c73.5-2.4,57.8-97.5,57.8-97.5L75.1,144.5z"
          />
          <path
            fill={colors.shadowBlue}
            d="M342.2,121.4l-106.1,24.2c0,0,7.6,96,71.6,83.2C358.8,218.6,342.2,121.4,342.2,121.4z"
          />
        </g>
        <g opacity="0.7">
          <path fill={colors.shadowBlue} d="M246.9,189.6c1.3,3,2.7,6.1,4.2,9l47-66.1l-11.3,1L246.9,189.6z" />
          <path
            fill={colors.shadowBlue}
            d="M293.2,229.9c4.5,0.3,9.3,0,14.6-1.1c29.7-5.9,36.5-41.5,37-70.1C331.5,176.9,307.7,209.9,293.2,229.9z"
          />
          <path
            fill={colors.shadowBlue}
            d="M312.4,128.2c-16.2,22.8-39,55.3-55.8,79.3c4.9,7,11,13.1,18.5,17.2c19.7-27.9,50.1-71.4,68.1-97.1
				c-0.5-3.9-0.9-6.2-0.9-6.2L312.4,128.2z"
          />
          <path
            fill={colors.shadowBlue}
            d="M200,163.3c-0.3-6.8-1-11.6-1.2-13l-67.5,96.4c2.9,0.5,6,0.8,9.3,0.7L200,163.3z"
          />
          <path fill={colors.shadowBlue} d="M186.7,149.4l-14-0.6l-61.4,88.4c3.2,2.6,6.7,4.9,10.5,6.6L186.7,149.4z" />
          <path fill={colors.shadowBlue} d="M124.6,146.7l-38.5,50.1c3.1,8.7,7,17.3,11.9,25l53.6-73.9L124.6,146.7z" />
        </g>
        <polygon fill={colors.darkGrey} points="76.3,183.5 8.3,211.1 12.5,218.9 78,192.3 		" />
        <path
          d="M348.9,125c-0.3-1.7-1.3-3.2-2.7-4.1c-1.4-1-3.2-1.3-4.9-0.9l-103.4,21c-4.2,1.4-6,3.6-5.7,4.9c-0.1,0-27.9,1.5-27.9,1.7
			c-1.2-1.8-3.2-4.2-5.3-4.3l-123.7-5.3c-1.9-0.1-3.7,0.6-5,2c-1.3,1.4-2,3.2-1.9,5.1c0.1,1.1,2,27.4,11.3,53.9
			c13,37,34.2,56,61.4,55.2l0.3,0c20.2-0.7,36.2-8,47.4-21.6c14.8-18,18-43.3,18-61.3c8.8,0.8,17.7-0.2,26.3-2.6
			c3.8,18.5,12.8,46.9,32.8,62.1c9.6,7.3,20.7,10.7,33,10.3c3.4-0.1,6.9-0.5,10.6-1.3C365.8,228.4,349.6,129.2,348.9,125z
			 M178.5,224c-8.7,10.6-21.3,16.2-37.5,16.8l-0.2,0c-43.1,1.4-55.3-66.4-58.2-89.3l110.3,4.8C194.1,169.3,195.5,203.4,178.5,224z
			 M207.2,168c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0,0,0,0c-0.1-8.4-0.9-14.9-1.3-17.9c0.5,0.1,1.1,0.2,2,0.2c0.8,1.4,2.2,3.5,2.7,6.2
			c0.6,2.5,0.5,5.4-0.4,7.5C209.1,166.4,207.5,167.6,207.2,168z M219.2,165.4l0,0.1l0,0l0,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.2,0.1
			c-0.2,0-0.5,0.1-0.7,0.1c-1,0.2-1.9,0.4-2.7,0.6c-2.1,0.4-3.9,0.8-5.1,1c0.4-0.3,0.7-0.7,1.1-1.1c0.9-1.1,1.6-2.5,1.9-4.1
			c0.7-3.1,0.2-6.5-1.2-9.1c-0.6-1.1-1.3-2.1-2.1-2.8c1.1-0.1,2.3-0.1,3.5-0.3c0.1,0.4,0.6,1,1.2,1.9c1.2,1.8,3.1,4.7,4,8.1
			C219.2,162,219.4,163.8,219.2,165.4z M215.2,150.2C215.3,150.2,215.3,150.2,215.2,150.2c3-0.3,6.1-0.7,8.9-1.2
			c0,0.1,0.1,0.2,0.1,0.3c0.2,0.9,0.4,1.8,0.5,2.7c0,0.1,0,0.2,0,0.3c-0.1,1-0.2,2.2-0.4,3.4c-0.3,1.9-0.8,3.8-1.4,5.7
			c-0.4-2-1.1-3.8-2-5.4C219.1,152.9,216.8,150.9,215.2,150.2z M232,163.1c-0.3,0.8-0.7,1.6-1.2,2.4c-2.7,0.8-5.5,1.4-8.3,1.7
			c0.2-0.2,0.4-0.3,0.6-0.5c1.1-1.2,2.5-3.3,3.3-5.7c0.9-2.4,1.1-5.1,1-7.3c-0.1-0.6-0.1-1.2-0.2-1.8c0,0,0,0,0,0
			c0-1.1-0.2-2.2-0.3-3.2c0-0.1,0-0.2,0-0.2c0.5-0.1,1.1-0.2,1.6-0.3c0.5,0.4,0.9,0.8,1.3,1.2c0,0,0.1,0.1,0.1,0.1
			c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0,0.3,0,0.4C230.5,151.4,230.9,156.1,232,163.1
			C232.1,163,232.1,163.1,232,163.1z M338.4,175.7c-2.7,30.7-13.3,48.1-31.3,51.7c-13.1,2.6-24.1,0.4-33.6-6.7
			c-21.1-16-28.1-51.9-30-65.5l93.9-21.5C338.5,142.5,339.9,158.9,338.4,175.7z"
        />
      </g>
    ),
    [HEADPHONES]: (
      <g id={HEADPHONES}>
        <path
          fill={colors.text}
          d="M390.9,150.8c-5.1-15.9-17.2-27.7-31.9-32.1c-4.5-4.7-7.9-6.9-8.2-7.1c-1.3-0.8-2.8-1.3-4.3-1.3c-0.1,0-0.2,0-0.3,0
        l-15,0.6c-0.4,0-0.9-0.1-1.3-0.1c-1.2,0-2.3,0.2-3.4,0.5c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0.1
        c-0.2,0.1-0.5,0.2-0.7,0.3c-9.1,3.4-10.6,14.1-11.3,27.8c0,0,13.7-0.8,13.8-0.7c2.7,5.4,10.5,22.7,13,31.9
        c0.9,3.3,2.1,5.5,5.5,23.1c2,10.2,1.2,30.9,1.3,31c3.1,1.5,5.7,2.8,8.8,2.8c1.1,0,2.2-0.1,3.3-0.4c0.1,0,0.1,0,0.2,0
        c0.1,0,0.1,0,0.2-0.1c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.4-0.1,0.6-0.2c1.1-0.4,2.1-0.9,3-1.5l16.9-9.1c2.2-1.2,3.8-3.4,4.1-5.9
        c0.1-0.6,1.1-7.9,0.9-18.6C393.3,180.1,395.5,165,390.9,150.8z"
        />
        <path
          fill={colors.secondary}
          d="M343.5,124.8c-4.4,10.5-4.6,25.8,0.4,41.4c4.8,15.2,13.5,27.3,22.8,33.5c15.1-8.9,22.5-28.1,16.6-46.5
        C377.5,135.1,360.8,123.7,343.5,124.8z"
        />
        <path
          fill={colors.secondary}
          d="M328.5,119.1l18-0.8c0,0,16,10.2,25.3,37.2c9.3,27,5.3,53.6,5.3,53.6l-19.2,10.3L328.5,119.1z"
        />
        <path
          fill={colors.secondaryDark}
          d="M358.3,164.9c8.1,27.7,6.3,57.1-1,55.1c-2.8-0.8-9.5-4.9-9.4-5.1c-1.9-37-9.6-54.4-20.2-76
        c0-0.1-5.6,0.3-5.6,0.3s0-3,0-4.4c0.4-8.7,2.5-14.5,6.3-15.6C336.8,116.6,350.1,137.1,358.3,164.9z"
        />
        <path
          d="M321,91.1c-0.5-0.4-1.1-1-1.9-1.6c-10.7-9.6-43.5-39-102.9-39c-5.9,0-11.9,0.3-17.9,0.9c-38.1,3.6-64.7,21.1-80.3,35.2
        c-16.9,15.3-24.8,29.6-25.1,30.2c-0.6,1.2-0.7,2.5-0.3,3.8c0.5,1.2,1.4,2.2,2.6,2.7c0,0,22.1,8.5,24.2,9.4
        c0.6,0.3,1.2,0.4,1.8,0.4c1.7,0,3.3-0.9,4.1-2.5c2.8-5.5,6.6-10.6,11.2-15.2c7.5-6,17.2-12.9,28.3-18.9
        c16.5-7.3,36.4-11.5,57.4-11.5c31.5,0,60.8,9.5,80.4,26.1c0.8,0.7,1.9,1.1,3,1.1c0.5,0,1-0.1,1.5-0.3c1.2-0.4,1.4-0.6,4.1-3.9
        c0.4-0.5,0.7-0.9,1-1.2c0.8-0.7,2-2,4.3-4.3c5-5,5-5.1,5.4-6C323,94.6,322.5,92.4,321,91.1z"
        />
        <path
          fill={colors.text}
          d="M329.3,115.5c-3.9-6.4-8.8-14.7-14-19.4c-1.4,2.4-2.9,4.8-4.6,7c4.9,4.4,9.2,9.7,13,15.8
          C325.3,118.5,327.6,117.5,329.3,115.5z"
        />
        <path
          fill={colors.text}
          d="M126.1,195.5C123.3,139,99.6,129,96.9,128c-0.9-0.3-1.8-0.5-2.7-0.5c-1,0-1.9,0.2-2.8,0.5L75,134.3
          c-7.6,1.5-11.8,9.3-14.1,17.2c-15.6,9.7-24.5,28.8-21.7,48.2c2.6,17.5,13.8,31.8,28.9,38c4.5,9.8,10.6,16.5,18.3,16.5
          c0,0,0.1,0,0.1,0l24,2.8c0.3,0,0.6,0.1,0.9,0.1c1.8,0,3.5-0.6,5-1.7C120.1,252.5,128.4,240.8,126.1,195.5z"
        />
        <path
          fill={colors.text}
          d="M99,122.8c-4.4,6.1-7.8,12.5-10.2,19c2.8,0.4,5.6,0.8,8.3,1.5c2.1-6.2,5.3-12.3,9.5-18.1
          C104.1,124.4,101.5,123.6,99,122.8z"
        />
        <path
          fill={colors.secondary}
          d="M94.2,135.6L77.1,142l9.8,104.2l24.6,2.9c0,0,9-7.1,6.7-53.2C115.5,143.1,94.2,135.6,94.2,135.6z"
        />
        <path
          fill={colors.text}
          d="M85.7,160.9c7.4-2,14.7-4.2,22.1-6.4c0.6-0.2,1.2-0.4,1.8-0.5c-0.5-1.2-1.1-2.3-1.6-3.3c-0.4,0.1-0.7,0.2-1.1,0.4
            c-7.3,2.4-14.6,4.7-21.9,7.1C83.2,158.7,83.9,161.4,85.7,160.9z"
        />
        <path
          d="M113.4,224.1c-7.1-1.3-14.2-2.6-21.3-4c-2.4-0.5-3.4,3.1-1,3.7c7.1,1.6,14.2,3.3,21.4,4.8c1.7,0.4,3.4,0.7,5.1,1
            c0.2-1.4,0.3-3,0.5-4.6C116.4,224.6,114.9,224.4,113.4,224.1z"
        />
        <path
          fill={colors.text}
          d="M94.2,210.8c-1-0.1-1.8,0.9-1.8,1.8c0,1.1,0.9,1.7,1.8,1.8c6.6,0.8,13.1,1.5,19.7,2.2c1.5,0.1,3,0.3,4.5,0.5
            c0-1.4,0.1-2.9,0.1-4.5c-1.5-0.1-2.9-0.2-4.4-0.3C107.5,211.9,100.8,211.4,94.2,210.8z"
        />
        <path
          fill={colors.text}
          d="M89,170.6c6.3-0.9,12.6-1.8,19-2.6c2-0.3,4.1-0.5,6.1-0.7c-0.4-1.5-0.8-3-1.2-4.4c-1.9,0.3-3.8,0.5-5.7,0.8
            c-6.4,0.9-12.8,2.1-19.1,3.3c-1,0.2-1.5,1.4-1.3,2.3C87,170.4,88,170.8,89,170.6z"
        />
        <path
          fill={colors.text}
          d="M96,206.7c6.2,0.8,12.4,1.5,18.6,2c1.3,0.1,2.6,0.2,3.9,0.3c0-0.9,0-1.9,0-2.8c-1.3-0.1-2.6-0.1-3.9-0.2
            c-6.2-0.3-12.4-0.7-18.6-1.1C94.8,204.8,94.8,206.5,96,206.7z"
        />
        <ellipse
          transform="matrix(0.9956 -9.408659e-02 9.408659e-02 0.9956 -17.8998 8.5762)"
          fill={colors.secondaryDark}
          cx="82"
          cy="194.1"
          rx="15.7"
          ry="52.3"
        />
        <path
          fill="none"
          stroke={colors.text}
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="
          M75.1,140.5c8.7-0.8,19.8,23.4,22.5,52.2s-4.1,55.2-12.8,56"
        />
        <path
          fill={colors.secondary}
          d="M81.8,233c6-9.6,8.7-24.7,6.3-40.9c-2.3-15.8-8.9-29.1-17.1-36.7c-16.4,6.3-26.7,24.1-23.9,43.2
          C49.9,217.4,64.6,231.3,81.8,233z"
        />
        <path
          fill="none"
          stroke={colors.text}
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="
          M62.3,228c10.3,5.7,17.4,4.7,19.6,4.9c6-9.6,8.7-24.7,6.3-40.9c-2.3-15.8-11-30.4-19.2-38c-1.4,0.5-2.7,1.1-4,1.8"
        />
        <path
          fill={colors.secondary}
          d="M116.9,126.7L97,119c0,0,30.4-56.3,101.7-63.1C272,49,309,86.8,318,94.5c-0.1,0.3-9.1,9.3-9.4,9.4
          c1.2,0-49.2-31.3-98.9-26.9S116.9,126.7,116.9,126.7z"
        />
        <path
          fill={colors.secondaryDark}
          d="M222.3,80.3c34.1,0,63.8,10.6,83.3,27.2c0.1,0,4.5-5.2,4.2-5.1c-21.1-16.8-52.1-27.5-87.6-27.5
          c-50,0-92.3,21-108,50.7c0.4,0.2,7.2,3,7.1,3C137.6,100.8,175.5,80.3,222.3,80.3z"
        />
        <path
          d="M194,229.7h-19.6c-4,0-7.4,2.7-8.5,6.3c-18.9,0.8-33.9-6.7-42.8-12.8c-1,2.6-2.5,5-4.2,7.2c-0.1,0.2-0.3,0.4-0.5,0.6
          c9.6,6.5,25,14.1,44.6,14.1c1.5,0,2.9-0.1,4.4-0.1c1.6,2,4.1,3.4,6.9,3.4H194c4.9,0,8.8-3.9,8.8-8.8v-1
          C202.8,233.6,198.9,229.7,194,229.7z"
        />
        <path
          d="M373.6,154.9c-9.4-27.3-26.1-40.3-26.8-40.8c-0.9-0.7-2.1-0.5-2.8,0.4c-0.7,0.9-0.5,2.1,0.4,2.8
        c0.1,0.1,10.4,8.1,19.1,24.3c0,0,0,0-0.1,0c-1.5,0.3-3.1,0.7-4.6,1c-2,0.5-4.1,1-6.1,1.5c-7.8-17.3-17.9-30.5-25.9-28.1
        c-1.1,0.3-1.7,1.4-1.4,2.5c0.3,1.1,1.4,1.7,2.5,1.4c4.2-1.2,13.1,8,21,25.5c-0.7,0.9-0.3,2.6,1.1,2.4c0.8,1.8,1.5,3.7,2.3,5.6
        c-1.5,1-0.8,3.5,1.2,3.2c1,2.8,2,5.8,2.9,8.9c2.1,7.2,3.6,14.6,4.5,21.7c-0.4,0.2-0.8,0.5-1.3,0.7c-2.3,1.4-0.5,4.8,1.8,4
        c1.3,13.8,0.4,25.4-2.4,29.5c-0.6,0.9-0.4,2.2,0.6,2.8c0.3,0.2,0.7,0.3,1.1,0.3c0.6,0,1.3-0.3,1.7-0.9c3.6-5.4,4.5-18.8,2.9-33.8
        c2.1-1.1,4.1-2.2,6.2-3.3c1.4-0.7,2.8-1.5,4.1-2.2c1.4,15.7,0,28,0,28.2c-0.1,1.1,0.7,2.1,1.8,2.2c0.1,0,0.2,0,0.2,0
        c1,0,1.9-0.7,2-1.8C379.7,211.7,383,182.1,373.6,154.9z M356,152c-0.6-1.6-1.3-3.2-1.9-4.8c1.8-0.3,3.6-0.5,5.4-0.9
        c1.6-0.3,3.1-0.5,4.7-0.8c0.4-0.1,0.8-0.1,1.3-0.2c0.6,1.3,1.3,2.7,1.9,4.1c-1.6,0.3-3.1,0.5-4.7,0.9
        C360.3,150.8,358.2,151.3,356,152z M373.8,179.9c-1.6,0.8-3.2,1.7-4.8,2.6c-1.5,0.8-3,1.6-4.5,2.5c-1-6.9-2.4-14-4.4-20.6
        c-0.8-2.9-1.8-5.8-2.8-8.6c2-0.4,4.1-0.9,6.1-1.2c1.5-0.3,3.1-0.5,4.7-0.7c0.2,0,0.5,0,0.8-0.1c0.3,0.8,0.6,1.7,0.9,2.5
        c2.6,7.7,4.2,15.7,5.1,23.1C374.6,179.5,374.2,179.7,373.8,179.9z"
        />
      </g>
    ),
    [SANTA]: (
      <g id={SANTA}>
        <path
          fill={colors.darkRed}
          d="M265.1,68c-1.9-2.9-3.9-5.7-5.9-8.5c-3-10.6-12.6-20.1-20.3-26.7c-8.6-7.4-19.6-16-31.4-18.4
        c-4.9-1.3-9.9-2-15-2.1c-13.8-0.3-28,4.1-38.8,12.8c-10.7,8.5-17.5,20.6-23.9,32.3c-6.1,11.2-12.2,23.2-22.2,31.5
        c-1.2,1-2.5,2.1-3.8,3c-1.1,0.9-1.5,2.4-0.7,3.6c0.7,1.1,2.5,1.6,3.6,0.7c1-0.6,1.9-1.2,2.8-1.9c3.1,0,6.1,0.6,9.1,1.6
        c3.7,1.3,6.8,3.3,9.8,5.7c1,0.8,2.8,1,3.7-0.2c7.7-10.8,21.6-16.5,34.6-13.9c1.4,0.3,2.9-0.6,3.2-2.1c2-9.6,11.5-16.3,21-16.7
        c10.5-0.5,20.3,6.4,25.7,15.1c1.1,1.8,1.7,3.9,4,4.1c1.8,0.1,3.5,0.3,5.2,0.6c4,0.6,7.8,1.7,11.6,3c1.1,0.4,2.6-0.4,3-1.4
        c3.9-9.2,12.5-16.3,22.4-18.1C264.9,71.8,266.3,69.8,265.1,68z"
        />
        <path
          fill={colors.darkRed}
          d="M265.1,68c-1.9-2.9-3.9-5.7-5.9-8.5c-2-7.2-7.1-13.8-12.5-19.4c-1.9-0.3-3.8-0.6-5.6-0.8
        c-16-1.8-32.5,0.6-47.4,6.7c-7.3,3-14.1,7-20.5,11.6c-3.7,2.6-8.4,6.5-13.2,4.2c-3.7-1.7-5.6-5.8-4.8-9.7c0.5-2.1-1.4-4.8-3.8-4.4
        c-9.6,1.5-16,7.8-22.3,14.7c-1.4,1.5-2.9,3.2-4.6,4.8c-4.6,8.1-9.7,15.9-16.8,21.8c-1.2,1-2.5,2.1-3.8,3c-1.1,0.9-1.5,2.4-0.7,3.6
        c0.7,1.1,2.5,1.6,3.6,0.7c1-0.6,1.9-1.2,2.8-1.9c3.1,0,6.1,0.6,9.1,1.6c3.7,1.3,6.8,3.3,9.8,5.7c1,0.8,2.8,1,3.7-0.2
        c7.7-10.8,21.6-16.5,34.6-13.9c1.4,0.3,2.9-0.6,3.2-2.1c2-9.6,11.5-16.3,21-16.7c10.5-0.5,20.3,6.4,25.7,15.1
        c1.1,1.8,1.7,3.9,4,4.1c1.8,0.1,3.5,0.3,5.2,0.6c4,0.6,7.8,1.7,11.6,3c1.1,0.4,2.6-0.4,3-1.4c3.9-9.2,12.5-16.3,22.4-18.1
        C264.9,71.8,266.3,69.8,265.1,68z"
        />
        <path
          fill={colors.darkRed}
          d="M107.5,184.4c-0.1-1-0.8-2-1.8-2.2c-2.5-0.4-5.1-0.9-7.6-1.4c-2.3-0.4-4.8-0.7-5.9,1.9
        c-0.4,1-0.5,2.2-0.7,3.2c-0.2,1.1-0.4,2.1-0.7,3.2c-0.5,1.9-1.1,3.8-1.9,5.5c-1.7,3.5-4.1,6.6-7.6,8.4c-1.5,0.8-3.1,1.3-4.8,1.5
        c-1.2,0.1-2.3,0-3.5-0.3c0-0.1,0-0.2,0-0.3c-0.1-2.1-2.8-2.4-3.7-0.8c-0.4,0.6-0.7,1.2-0.9,1.8c-1.8,0.6-3.7,1.4-4.9,3
        c-1.5,1.9-1.4,4.5,0.1,6.4c1.8,2.2,4.6,3.4,7.1,4.5c2.7,1.3,5.6,2.3,8.6,2.8c5.7,0.8,11.2-0.7,15.6-4.4c4.3-3.5,7.4-8.3,9.5-13.4
        C107,197.8,108,191.1,107.5,184.4z"
        />
        <path
          fill={colors.white}
          d="M333.3,122.3c-0.8-7.3-7.3-11.9-14.2-12.9c-3.4-0.5-6.9-0.3-10.3,0.7c-2.4-8.5-11.8-13.9-20.3-12.2
        c-1.2-10.5-6.2-21.2-16.3-25.7c-5-2.2-10.9-2.9-16.1-0.9c-5.3,2-9.4,6.4-12,11.3c-1.6,3.1-2.7,6.5-3.4,9.9c0,0,0,0,0,0
        c-6.2-4.1-15.6-5.3-22.8-4.2c-1.5-10.3-7.5-19.5-17.7-21.9c-11.8-2.8-24.4,2.3-31.6,11.8c-1.5,2-2.9,4.3-4,6.6
        c-3.5-1.2-7.1-1.7-10.9-1.3c-4.2,0.5-8.2,1.9-11.7,4.3c-5.4,3.8-9,9.4-10.4,15.7c-4.3-3.4-9.3-6-14.7-6.8
        c-5.5-0.8-10.9-0.1-15.9,2.4c-4.6,2.3-8.5,6.1-10.8,10.7c-2.2,4.5-2.6,9.6-1.3,14.4c0.7,2.5,1.8,4.8,3.3,6.8
        c-7.4,0.1-14.8,2.3-19.2,8.6c-2.5,3.6-4,8.2-3.3,12.6c0.7,4.7,3.6,8.5,7.9,10.6c2.1,1,4.4,1.6,6.7,1.9c-0.1,0.2-0.2,0.5-0.3,0.7
        c-1.6,3.9-0.6,8.1,2.4,11c2.8,2.7,6.9,4,10.8,3.6c3.5-0.4,6.7-1.8,9.6-3.8c3.5,6.3,9.9,10.8,17,11.9c8.5,1.3,17-2.6,21.9-9.6
        c1.5-2.1,2.6-4.5,3.4-6.9c5.3,5.7,12.2,10.1,19.9,11.1c4.9,0.6,9.6-0.1,14-2.4c4-2.2,7.5-5.7,9.6-9.8c0.8-1.5,1.3-3.1,1.7-4.7
        c2.4,1.9,4.9,3.6,7.5,5.3c3.2,2.1,6.6,4.1,10.3,4.8c3.6,0.7,7.5,0.1,10.5-2.1c2.7-1.9,4.8-4.7,6-7.8c1.1-2.7,1.6-5.5,2-8.3
        c1.2,1.1,2.2-0.9,3.3,0.3c2.2,2.3,5.9,3.5,8.6,5c5.7,3.2,11.5,8.4,18,8.3c13-0.2,23.4-6,30.2-17.3c0.5-0.8,3-1.9,3.5-2.8
        c0.2,0.1-2.4-1.3-2.1-1.2c2.9,0.6,7.7,0.9,10.6,0.7c3-0.2,6.8,0.8,9.6-0.2c5.6-2.1,10.7-5.6,14.5-10.2
        C330.8,135.4,334,128.8,333.3,122.3z"
        />
        <path
          fill={colors.white}
          d="M57.8,182c-4.6-7.2-13.7-11-22.1-9.3c-8.3,1.7-16,9.2-16.7,17.9c-0.3,3,0.4,6.2,2.2,8.5
        c-4.3,5-2.5,12.6,2,16.9c5,4.8,12.9,6.3,19.6,5.8c6.7-0.6,13.3-3.2,17.9-8.2c1.1-1.2,2.1-2.6,2.9-4.1c0.4-0.7,0.8-1.5,1.4-2
        c0.7-0.6,1.4-1.1,2.1-1.7c2.6-2.3,4.1-5.7,4.4-9.2C72.2,188.6,65.5,181.9,57.8,182z"
        />
        <path
          fill={colors.shadowBlue}
          d="M333.3,122.3c-0.8-7.3-7.3-11.9-14.2-12.9c-1-0.2-2-0.2-3-0.3c-0.6,0.3-1.3,0.4-2.2,0.4
        c-5.2-0.2-7.8,3.8-10.2,7.9c-2.7,4.7-5,9.7-8.5,13.9c-3.7,4.5-8.9,7.4-14.8,7.5c-5.5,0.1-10.7-2.6-15.9-3.9
        c-2.5,2-5.4,3.6-8.7,3.9c-8.2,0.8-12.5-7.8-14-11.8c-3.9,2.6-8.5,7-9.8,8c-5.7,4.4-13,9.3-20.6,8.6c-6.2-0.5-13.3-4-17.1-8.8
        c-6.4,7.4-15.9,4.2-18.4,2.3c-2.2,3.7-5.2,6.9-9.3,8.8c-5.3,2.5-12.4,3-18.6,1.5c-2.5,4.2-6,7.9-10.2,10.7
        c-4.6,2.9-10.7,4.9-16.1,4c-5.3-0.9-8.5-4.7-11.7-8.7c-1.7-2.1-2.5-3.2-5.1-3c-2.3,0.2-4.6,1-6.9,1.5c-4.6,1-9.3,1.8-14,1.9
        c-5.3,0.1-10.4-0.9-14.4-3.5c0,0.6,0.1,1.2,0.2,1.8c0.7,4.7,3.6,8.5,7.9,10.5c2.1,1,4.4,1.6,6.7,1.9c-0.1,0.2-0.2,0.5-0.3,0.7
        c-1.6,3.9-0.6,8.1,2.4,11c2.8,2.7,6.9,4,10.8,3.6c3.5-0.4,6.7-1.8,9.6-3.8c3.5,6.3,9.9,10.8,17,11.9c8.5,1.3,17-2.6,21.9-9.6
        c1.5-2.1,2.6-4.5,3.4-6.9c5.3,5.7,12.2,10.1,19.9,11.1c4.9,0.6,9.6-0.1,14-2.4c4-2.2,7.5-5.7,9.6-9.8c0.8-1.5,1.3-3.1,1.7-4.7
        c2.4,1.9,4.9,3.6,7.5,5.3c3.2,2.1,6.6,4.1,10.3,4.8c3.6,0.7,7.5,0.1,10.5-2.1c2.7-1.9,4.8-4.7,6-7.8c1.1-2.7,1.2-7.5,1.6-10.3
        c1.2,1.1,2.9,2.5,4,3.7c2.2,2.3,5.5,4.8,8.3,6.3c5.7,3.2,11.5,5.7,18,5.6c13-0.2,23.8-6,30.5-17.3c0.5-0.8,0.6-2.1,1-3
        c0.2,0.1,0.1-0.7,0.3-0.7c2.9,0.6,8.2,2.2,11.2,2c3-0.2,6-0.8,8.8-1.9c5.6-2.1,10.7-5.6,14.5-10.2
        C330.8,135.4,334,128.8,333.3,122.3z"
        />
        <path
          fill={colors.shadowBlue}
          d="M69.1,187.8c-4.8,0.9-9.5,4-13,7.4c-2.6,2.5-5.6,6.1-9.4,6.8c-1.2,0.2-2.7-0.1-3.4-0.7
        c-0.9-0.8-1.5-1.9-1.6-2.8c-0.2-1.5-0.1-2.2,0.8-3.5c1.3-1.9-0.8-4-2.6-4c-3.8-0.1-7.3-2.5-9-5.9c-1.7-3.3-1.3-7.7,0.7-10.8
        c0.6-0.1,1.1-0.4,1.5-0.9c0,0,0.1-0.1,0.1-0.1c-7.3,2.5-13.6,9.4-14.2,17.2c-0.3,3,0.4,6.2,2.2,8.5c-4.3,5-2.5,12.6,2,16.9
        c5,4.8,12.9,6.3,19.6,5.8c6.7-0.6,13.3-3.2,17.9-8.2c1.1-1.2,2.1-2.6,2.9-4.1c0.4-0.7,0.8-1.5,1.4-2c0.7-0.6,1.4-1.1,2.1-1.7
        c2.6-2.3,4.1-5.7,4.4-9.2C71.8,193.3,70.9,190.3,69.1,187.8z"
        />

        <path
          fill={colors.text}
          d="M331.8,111.8c-2.2-3.1-5.4-5-8.5-5.9c-3.2-0.9-6.3-1-9.1-0.4c-1.6,0.3-3.1,0.9-4.4,1.6c-0.1-0.4-0.1-0.8-0.2-1.3
          c-0.5-1.9-1.4-4.1-3-5.9c-1.5-1.9-3.6-3.5-6-4.5c-2.3-1-4.8-1.3-7-1c-1.5,0.1-2.9,0.5-4,1.1c0.4-2.2,0.5-4.7,0.2-7.4
          c-0.7-5.6-3.5-11.9-8.9-16.4c-1.3-1.1-2.8-2.1-4.5-2.9c-1.6-0.7-3.4-1.4-5.1-1.7c-1.9-0.4-3.9-0.6-5.9-0.5
          c-0.2-0.7-0.4-1.5-0.8-2.6c-0.4-1.1-0.9-2.3-1.5-3.7c-0.6-1.4-1.3-2.9-2.1-4.6c-0.8-1.7-1.8-3.5-2.9-5.4
          c-4.4-7.6-11.1-16.9-21-25.3c-4.9-4.2-10.6-8-17.1-11.1c-6.4-3.1-13.6-5.3-21-6.4c-7.4-1-15.1-0.9-22.6,0.6
          c-7.5,1.4-14.7,4.2-21.1,8.2c-3.2,2-6.1,4.4-8.8,6.9c-2.6,2.6-4.9,5.4-7,8.2c-4.1,5.7-7.1,11.7-9.8,17.3
          c-2.6,5.6-4.9,10.9-7.1,15.7c-2.2,4.8-4.3,9-6.4,12.6c-4.1,7.2-8.2,11.4-9.8,13.3c-1.8,2-3.1,3.2-4,4.1c-0.5,0.1-1,0.3-1.5,0.4
          c-5.6,1.8-10.8,5.7-14.1,10.9c-3.3,5.3-4.1,11.6-3,16.9c0.7,3.6,2.3,6.6,4.2,9c-0.5,0-1-0.1-1.6,0c-2.3,0-5.5,0.4-9.1,1.9
          c-3.6,1.5-7.4,4.4-9.7,9c-1.1,2.3-1.7,5-1.5,7.7c0.2,2.7,1.2,5.3,2.6,7.4c2.8,4.3,7.2,6.9,11.4,7.8c0.7,0.1,1.3,0.2,2,0.3
          c-0.3,2.5,0,5,0.9,7.3c0.7,1.7,1.6,3.1,2.9,4.4c0.1,0.1,0.2,0.2,0.2,0.2c0.2,1.1,0.5,2.3,0.6,3.4c0.2,1.8,0.3,3.6,0.3,5.5
          c-0.1,3.2-0.6,6.5-1.7,9.5c-1,2.7-2.7,5.1-5.2,6.6c-2.3,1.4-5.3,1.9-7.8,0.8c-0.1-0.1-0.3-0.1-0.4-0.1c1-2,1.6-4.4,1.7-7
          c0.1-1.9-0.2-3.9-0.9-5.8c-0.6-1.9-1.6-3.7-3.1-5.2c-1.4-1.6-3.3-2.7-5.2-3.3c-1.8-0.6-3.6-0.7-5.3-0.6c0-0.8-0.2-1.8-0.7-2.8
          c-0.6-1.3-1.5-2.8-2.9-4.1c-1.4-1.3-3.2-2.3-5.1-3.1c-1.9-0.8-3.9-1.3-6.1-1.7c-2.2-0.4-4.5-0.6-6.9-0.5
          c-2.4,0.1-4.9,0.5-7.4,1.3c-2.4,0.8-4.9,2.1-6.8,3.8c-2,1.7-3.7,3.8-4.8,6.1c-1.2,2.3-1.8,4.8-1.7,7.2c0,1.2,0.2,2.4,0.5,3.5
          c0.3,1.1,0.8,2.1,1.3,3c0.7,1.1,1.4,2,2.3,2.7c-0.3,0.2-0.7,0.4-1.1,0.7c-0.8,0.7-1.7,1.8-2.3,3.3c-0.6,1.5-1.1,3.5-1,5.6
          c0,1.1,0.2,2.2,0.5,3.4c0.4,1.2,0.8,2.3,1.5,3.4c1.2,2.2,3,4.2,5.1,5.9c2.1,1.7,4.4,3,6.9,4.2c2.5,1.1,5.3,2,8.1,2.4
          c2.9,0.5,5.8,0.5,8.8,0c2.9-0.5,5.8-1.5,8.2-3.1c2.5-1.6,4.5-3.7,5.9-6c0.4-0.6,0.7-1.3,1.1-2c0.4,0.6,0.9,1.3,1.5,2
          c0.8,1,1.9,2.1,3.2,3.3c1.4,1.1,3,2.3,5.1,3.2c2.1,0.9,4.5,1.4,7.1,1.5c2.5,0,5.1-0.4,7.6-1.2c5-1.7,9.5-5,12.8-9.1
          c3.2-4.1,5.4-8.6,6.7-13c1.3-4.3,1.8-8.4,1.8-11.8c0-3.4-0.4-6-0.9-7.6c-0.1-0.2-0.2-0.4-0.3-0.6c0.1-0.1,0.2-0.1,0.3-0.2
          c0.1,0.3,0.3,0.6,0.4,0.9c1.1,1.9,3.1,4.3,6.1,6.3c2.9,2,6.7,3.6,11,4.1c1.1,0.2,2.2,0.1,3.3,0.2c1.1-0.1,2.2-0.1,3.3-0.3
          c1.1-0.2,2.2-0.5,3.3-0.8c1.1-0.4,2.1-0.8,3.1-1.3c1-0.5,1.9-1.1,2.8-1.7c0.9-0.7,1.7-1.3,2.5-2.1c1.5-1.5,2.8-3.1,3.8-4.8
          c1.6-2.6,2.5-5.4,2.9-7.8c0,0.1,0.1,0.1,0.1,0.2c1,2.3,2.9,5.3,5.9,8.1c3,2.8,7.1,5.3,12.1,6.3c4.9,1.1,10.4,0.7,15.1-1.3
          c2.4-1,4.6-2.3,6.5-3.9c1.9-1.6,3.5-3.5,4.7-5.5c1.7-2.8,2.5-5.8,2.7-8.4c0,0,0,0.1,0.1,0.1c1.2,1.4,3.1,3.1,5.6,4.6
          c2.5,1.5,5.8,2.8,9.6,3.1c3.7,0.4,7.7-0.3,11.2-2.2c1.7-0.9,3.3-2.2,4.6-3.6c1.3-1.4,2.2-3,2.9-4.6c1.2-2.9,1.5-5.6,1.4-7.9
          c0.1,0.2,0.2,0.3,0.3,0.5c0.4,0.6,0.8,1.1,1.3,1.7c2.1,2.4,5.5,5.2,10,7.3c4.5,2.1,10,3.5,15.9,3.8c5.8,0.3,12.1-0.4,17.9-2.7
          c5.8-2.2,10.9-6.2,14-11c1.5-2.3,2.5-4.7,3.2-7.1c1,0.5,2.4,1,4.1,1.4c3.4,0.7,8.3,1,13.7-0.6c2.7-0.8,5.5-2,8.1-3.8
          c2.6-1.8,5.1-4,7.2-6.7c4.2-5.3,6.8-12.3,6.5-19.5C335,118.6,334,114.8,331.8,111.8z M106.6,93.3c2-1.4,4.5-3.5,7.2-6.4
          c2.7-2.9,5.4-6.6,8-10.9c2.7-4.3,5.2-9.2,7.8-14.5c2.6-5.3,5.3-10.9,8.4-16.5c3.1-5.6,6.7-11.1,11.3-15.9
          c2.3-2.4,4.8-4.5,7.6-6.4c0.7-0.5,1.4-0.9,2.1-1.3c0.7-0.4,1.4-0.9,2.2-1.3l2.3-1.2c0.4-0.2,0.8-0.4,1.1-0.6l1.2-0.5
          c6.3-2.7,13.2-4.3,20.1-4.6c6.9-0.4,13.9,0.3,20.4,2c6.6,1.6,12.6,4.4,18.2,7.6c11,6.5,19.5,15.1,25.7,22.8
          c3.1,3.9,5.6,7.6,7.7,10.8c1,1.6,2,3.1,2.8,4.5c0.8,1.4,1.6,2.6,2.3,3.7c0.5,0.8,0.9,1.5,1.2,2c-1.2,0.1-2.3,0.3-3.4,0.5
          c-6.8,1.5-12.8,5.8-16.3,10.9c-3.1,4.4-4.6,9.2-5.2,13.2c-0.1-0.2-0.2-0.4-0.4-0.6c-0.8-1.1-2.2-2.3-4-3.4
          c-1.8-1.1-4.2-1.9-6.7-2.3c-2.5-0.4-5.3-0.3-7.9,0.4c-0.5,0.1-1,0.3-1.5,0.5c0-0.3-0.1-0.7-0.1-1c-0.1-0.7-0.3-1.5-0.6-2.2
          c-0.3-0.7-0.6-1.5-0.9-2.4c-0.8-1.6-1.7-3.4-3.1-5c-1.3-1.7-2.9-3.4-4.7-4.9c-1.8-1.5-4-2.9-6.3-4c-4.6-2.3-10.2-3.3-15.5-2.6
          c-5.4,0.7-10.3,3.1-13.8,6.2c-3.6,3-6,6.7-7.2,10c-0.6,1.6-0.9,3-1.1,4.3c0,0-0.1,0-0.1,0c-3.5-0.9-7.7-1.4-12.1-0.7
          c-2.2,0.3-4.4,0.8-6.5,1.6c-1.1,0.4-2.1,0.9-3.2,1.4c-1,0.6-2,1.1-3,1.8c-0.9,0.6-1.7,1.3-2.5,2c0.2-2.4,0.2-4.7-0.1-6.7
          c-0.5-3.4-1.4-5.7-2-6.3c-1.5-1.4-2.4-0.6-2.7,1.3c-0.4,1.9-0.6,4.8-1,8.1c-0.4,3.3-1,6.8-1.7,10c-0.4,2-0.8,3.9-0.9,5.5
          c-0.5-0.6-1.2-1.3-2-2c-2.2-2-5.7-4.3-10.3-5.6c-2.3-0.7-4.9-1.1-7.6-1.1c-1.1,0-2.2,0.1-3.4,0.2
          C106.3,93.4,106.4,93.4,106.6,93.3z M59.9,205.5c0,1.5-0.4,3.1-1.1,4.8c-0.7,1.6-1.7,3.3-3.1,4.7c-0.7,0.7-1.4,1.3-2.3,1.9
          c-0.4,0.3-0.8,0.5-1.3,0.8c-0.5,0.2-0.9,0.5-1.4,0.7c-3.9,1.7-8.8,1.8-13.3,0.7c-4.5-1-8.8-3.1-11.8-5.7
          c-1.5-1.3-2.7-2.7-3.4-4.2c-0.8-1.4-1.2-2.9-1.3-4.3c-0.3-2.7,0.5-4.6,0.7-5.4c0.2-0.8,0.5-1.4,0.6-1.9c0.2,0.2,0.4,0.3,0.6,0.5
          c1.4,0.9,2.9,1.4,4.2,1.6c1.3,0.1,2.3-0.1,3-0.4c1.4-0.7,1.4-1.3,0.7-1.6c-0.7-0.4-2-0.7-3.6-1.7c-1.6-1-3.4-3.1-4.1-5.7
          c-0.1-0.7-0.3-1.3-0.2-2c0-0.7,0.1-1.5,0.3-2.2c0.4-1.5,1.1-3.1,2.2-4.5c1.1-1.4,2.4-2.7,4-3.7c1.5-1,3.4-1.7,5.2-2.2
          c3.8-0.9,7.8-0.9,11.3-0.3c3.6,0.5,6.4,1.5,8.2,2.9c1.7,1.3,2.5,2.8,2.9,3.5c-0.8,0.2-1.6,0.5-2.3,0.8c-1.3,0.6-2.4,1.4-3.4,2.1
          c-1.8,1.5-2.9,3-3.4,4.2c-0.5,1.2-0.2,1.7,0.5,1.6c0.7,0,1.9-0.6,3.4-1.3c1.5-0.7,3.4-1.6,5.5-1.9c2-0.4,4.4-0.2,6.3,0.8
          c0.9,0.5,1.7,1.2,2.4,2.2c0.7,1,1.2,2.2,1.5,3.4c0.3,1.2,0.4,2.5,0.4,3.7c0,0.6-0.1,1.2-0.2,1.9c-0.2,0.6-0.2,1.2-0.5,1.8
          c-0.6,2-1.6,3.6-2.5,4.9c-0.1-1-0.2-2-0.5-2.8c-0.6-1.9-1.5-3.4-2.5-4.5c-1-1.1-1.9-1.8-2.6-2.4c-0.7-0.6-1.2-1-1.6-1.1
          c-0.3-0.1-0.5,0.2-0.4,0.9c0.1,0.6,0.4,1.5,0.8,2.5c0.5,1,1.1,2.1,1.4,3.1C59.7,202.7,59.9,204,59.9,205.5z M104.8,186.2
          c-0.5,2.6-1.2,6-2.3,9.6c-1.1,3.6-2.7,7.5-4.9,11.1l-0.9,1.4l-0.9,1.3l-1,1.2l-1.1,1.2c-1.5,1.5-3.1,2.9-4.9,3.9
          c-3.5,2.2-7.5,3.3-11,3.1c-1.7-0.1-3.4-0.5-4.8-1.1c-1.4-0.6-2.7-1.3-3.8-2c-2.2-1.4-3.7-2.7-4.5-3c-0.4-0.2-0.7-0.3-0.9-0.5
          c0.2-0.5,0.3-1,0.4-1.5c0.2-0.1,0.3-0.1,0.5-0.2c1.8-0.8,3.9-2.3,5.7-4.8c0.1,0.1,0.3,0.3,0.5,0.4c3.1,1.7,6.9,1.7,10.2,0.3
          c3.5-1.4,6.1-4.1,7.9-7.4c1.9-3.4,2.7-7.4,3.1-11.3c0.2-1.9,0.2-3.9,0.2-5.9c3.1,1.4,6.8,1.7,10,1.1c1.2-0.2,2.3-0.6,3.4-1
          C105.5,183.1,105.2,184.5,104.8,186.2z M328.7,125.5c-0.3,2.8-1.1,5.5-2.3,8c-2.3,5.1-6.2,9.2-10.4,11.7
          c-4.2,2.6-8.6,3.6-12.1,3.9c-3.5,0.4-5.9,0-7,0.1c-0.4,0-0.7,0-1,0c0.3-1.7,0.4-3.4,0.4-5c-0.1-2.1-0.6-3.9-1.1-5.4
          c-0.3-0.7-0.6-1.4-0.9-1.9c-0.4-0.5-0.7-1-1-1.4c-1.4-1.4-1.9-1.3-1.9-0.3c0,0.3,0,0.6,0.1,0.9c0.1,0.4,0.1,0.8,0.2,1.3
          c0.2,1,0.3,2.2,0.3,3.6c0,2.8-0.5,6.6-2.4,10.3c-0.9,1.9-2.2,3.8-3.7,5.4c-1.6,1.6-3.5,3.2-5.6,4.4c-4.3,2.6-9.6,4-14.8,4.5
          c-5.2,0.5-10.4,0.1-14.8-1c-4.4-1.1-8.2-2.7-10.8-4.4c-2.7-1.6-4.4-3.1-5.2-3.7c-1-0.7-1.6-1.2-2.1-1.4c-0.3-1.2-0.6-2.1-1-2.8
          c-0.7-1.1-1.2-1.2-1.6-0.6c-0.4,0.6-0.7,1.9-1.1,3.7c-0.3,1.8-0.8,4-1.6,6.2c-0.8,2.2-2.1,4.4-4,5.9c-1.9,1.6-4.6,2.7-7.4,3
          c-2.8,0.4-5.5,0-8-0.7c-2.5-0.7-4.6-1.7-6.2-2.5c-1.6-0.8-2.8-1.5-3.4-1.7c-0.2-0.1-0.4-0.1-0.6-0.2c-0.3-3.2-1.3-5.5-2.4-6.7
          c-1.1-1.2-1.6-1.1-1.8-0.3c-0.1,0.8,0.1,2.5,0,4.7c-0.1,1.1-0.2,2.4-0.5,3.8c-0.3,1.4-0.8,2.8-1.5,4.3c-1.4,3-3.6,5.8-6.9,7.8
          c-3.2,2-7.2,3.1-11.2,3.2c-3.9,0-7.7-1.1-10.8-2.7c-3.1-1.7-5.5-3.8-7.2-5.6c-1.7-1.8-2.8-3.3-3.3-3.9c-0.6-0.6-1.1-1.1-1.5-1.3
          c-0.2-1.6-0.6-2.8-1.1-3.6c-0.8-1.2-1.3-1.3-1.7-0.6c-0.4,0.7-0.5,2.1-1,4c-0.4,1.9-1.2,4.3-2.6,6.8c-1.4,2.5-3.4,5-6,7
          c-2.6,2-5.7,3.2-9.1,3.6c-1.6,0.2-3.3,0.2-4.9-0.1c-0.8-0.1-1.6-0.3-2.4-0.4c-0.7-0.2-1.5-0.4-2.2-0.7c-2.8-1-5.2-2.4-6.8-3.7
          c-0.4-0.3-0.8-0.6-1.1-0.9c-0.3-0.3-0.7-0.5-0.9-0.8c-0.1-0.1-0.2-0.2-0.4-0.3c0.2-0.2,0.4-0.3,0.6-0.5c2.2-2,3.6-4.3,4.3-6.3
          c0.8-2,0.9-3.7,0.7-4.8c-0.2-1.2-0.7-1.4-1.3-1.1c-0.6,0.3-1.3,1.2-2.2,2.3c-0.9,1.2-2.1,2.6-3.6,4c-1.5,1.4-3.3,2.6-5.5,3.4
          c-2.1,0.8-4.6,1.1-6.8,0.7c-2.3-0.3-4.2-1.3-5.7-2.7c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2-0.4-0.6-0.8-1-1.1c-0.9-1.1-1.5-2.2-1.9-3.1
          c-0.6-1.4-0.8-2.5-1-3c-0.2-0.6-0.5-1.1-0.7-1.4c1.9-0.1,3.7-0.5,5.2-1c2.9-0.9,5-2.2,6.1-3.2c1.1-1.1,1.1-1.6,0.2-1.8
          c-0.9-0.1-2.5,0.1-4.8,0.4c-2.2,0.3-5.1,0.5-8.1,0.1c-1.5-0.2-3.1-0.6-4.5-1.2c-1.4-0.6-2.8-1.5-4-2.7c-2.4-2.3-4-5.5-3.7-8.6
          c0.3-3.1,2.3-6.2,4.7-8.2c2.4-2,5.1-3.2,7.3-4c2.2-0.8,3.8-1.2,4.5-1.5c0.4-0.2,0.7-0.4,1-0.5c0.4,0.3,0.7,0.6,1.1,0.9
          c3.1,2.4,6,3.4,7.9,3.7c1.9,0.3,2.3-0.1,1.7-0.9c-0.6-0.8-2.4-2.1-4.5-4c-1-1-2.1-2.1-3.1-3.4c-1-1.3-1.8-2.9-2.5-4.7
          c-1.3-3.6-1.5-8.1,0-12.4c0.7-2.1,1.8-4.1,3.3-5.9c1.5-1.8,3.3-3.3,5.3-4.6c4-2.5,8.6-3.6,12.7-3.5c4.2,0.1,7.8,1.3,10.5,2.4
          c2.7,1.2,4.5,2.4,5.3,2.8c0.6,0.3,1.1,0.5,1.5,0.7c-0.3,1.2-0.4,2.4-0.4,3.5c-0.1,3,0.5,5.3,1.3,6.6c0.8,1.3,1.3,1.3,1.7,0.6
          c0.4-0.7,0.5-2.3,0.9-4.4c0.4-2.1,1.1-4.7,2.5-7.5c1.4-2.7,3.4-5.6,6-8c2.6-2.4,5.8-4.3,9.3-5.4c1.7-0.5,3.5-1,5.3-1.2
          c0.9-0.1,1.7-0.2,2.6-0.2c0.8,0,1.7-0.1,2.5,0c6.6,0.2,11.4,2.3,12.8,2.5c1.8,0.4,2.6,0.2,2.5-0.4c-0.1-0.6-1.1-1.8-3-3.1
          c-1.3-0.8-2.9-1.8-4.9-2.5c0.2-0.4,0.4-0.8,0.6-1.2c1.1-2.2,2.9-4.8,5.4-7.3c2.6-2.5,6-4.7,9.9-5.9c3.9-1.2,8.3-1.3,12.3-0.2
          c4.1,1,7.8,3,10.8,5.4c3,2.3,5,5,6.4,7.2c1.1,1.6,1.7,3,2,3.9c-0.9,0.5-1.7,1-2.4,1.6c-1.8,1.5-3.2,3.1-4,4.7
          c-0.8,1.6-1.1,2.9-0.9,4c0.9,4,4-2.6,11.3-5.3c1.8-0.7,3.7-1.1,5.6-1.2c1.9-0.1,3.9,0.1,5.6,0.4c3.5,0.7,6,2.2,6.9,2.3
          c0.4,0.1,0.8,0.1,1.1,0.1c-0.3,4,0.3,7.2,1,9.2c0.8,2.1,1.3,2.2,1.7,1.1c0.3-1.1,0.5-3.6,1.1-7c0.6-3.3,1.7-7.6,3.9-11.7
          c2.3-4.2,5.9-8.1,10.7-10.3c4.8-2.3,10.7-2.9,15.6-1c4.9,1.8,8.6,6.1,10.5,10.5c2,4.4,2.1,8.9,1.8,12.3c-0.3,3.4-1.1,5.8-1.2,6.9
          c-0.2,1.4-0.4,2.3-0.4,2.8c0,0.6,0.2,0.7,0.6,0.6c0.7-0.4,2.2-2.1,3.6-5.3c0.1-0.3,0.3-0.6,0.4-1c1.9-0.3,4.9-0.9,8.2,0
          c1.5,0.4,3,1.1,4.3,2.1c1.3,1,2.4,2.2,3.3,3.5c0.9,1.3,1.5,2.6,1.9,3.7c-2.8,2.6-4,5.4-4.4,7.3c-0.3,2.2,0.2,2.5,0.9,1.7
          c0.8-0.8,2.1-2.7,4.6-4.7c1.2-1,2.7-1.9,4.5-2.6c0.9-0.3,1.8-0.6,2.8-0.8c1-0.2,2-0.2,3.1-0.2c2.1,0.1,4.4,0.7,6.3,1.9
          c1.9,1.2,3.4,2.9,4.2,5.2C328.8,120,329,122.8,328.7,125.5z"
        />
        <path
          fill={colors.text}
          d="M196.9,131.4c-0.5-0.8-1-0.9-1.5-0.7c-0.5,0.2-0.9,0.8-1.4,1.5c-0.6,0.7-1.1,1.6-2,2.5c-0.9,0.9-2,1.8-3.3,2.6
          c-1.3,0.8-2.8,1.3-4.3,1.6c-1.5,0.3-3,0.2-4.3-0.1c-1.3-0.3-2.5-0.8-3.3-1.3c-0.5-0.3-0.9-0.6-1.2-0.8c0.1-1,0-1.9-0.2-2.6
          c-0.5-1.5-1-1.6-1.5-1c-0.5,0.6-1,2.1-2,3.8c-1.1,1.8-2.8,3.9-5.3,5.5c-2.4,1.7-5.7,2.7-9.4,2.6c-3.6,0-7.5-1.1-10.6-2.9
          c-1.5-0.9-2.7-2-3.3-3.2c-0.7-1.3-0.9-2.9-0.9-4.4c0.1-3.1,1.6-5.7,3-7.6c1.4-1.9,2.6-3.2,3-3.8c1.1-1.6,1.3-2.4,0.6-2.6
          c-0.6-0.1-2.1,0.4-4.2,1.7c-2,1.3-4.7,3.5-6.5,7.4c-0.9,1.9-1.5,4.2-1.4,6.7c0,1.3,0.2,2.6,0.6,3.9c0.4,1.3,1.1,2.6,2,3.7
          c1.8,2.2,4,3.6,6.1,4.7c2.2,1.1,4.5,1.8,6.9,2.3c4.8,0.8,9.8,0.2,13.8-1.9c4-2,6.7-5.2,8-8.1c0,0,0,0,0-0.1
          c0.5,0.6,1.1,1.2,1.8,1.7c1.6,1.2,3.8,2.1,6.2,2.3c2.4,0.2,4.9-0.2,7.1-1.2c2.2-0.9,4-2.4,5.4-4c1.4-1.6,2.1-3.4,2.4-4.9
          c0.1-0.4,0.1-0.7,0.1-1.1c0-0.4,0-0.7-0.1-1C197.4,132.3,197.1,131.8,196.9,131.4z"
        />
        <path
          fill={colors.text}
          d="M266.7,131.9c-0.6,0.2-1.5,0.8-2.7,1.5c-1.2,0.7-2.9,1.5-4.8,1.9c-2,0.4-4.1,0.3-6.2-0.7c-2.1-0.9-4.1-2.6-5.3-4.7
          c-1.2-2.1-1.7-4.4-1.5-6.7c0.2-2.2,1-4.2,1.7-5.6c0.8-1.4,1.6-2.4,1.8-2.9c0.7-1.3,0.9-2,0.3-2.2c-0.5-0.2-1.8,0-3.4,1
          c-1.6,1-3.4,2.9-4.7,5.7c-1.3,2.7-1.9,6.4-1,10.1c0.9,3.7,3.2,7,6.3,9.2c1.5,1.1,3.2,1.9,5,2.4c1.8,0.5,3.6,0.6,5.2,0.4
          c3.3-0.4,6-1.9,7.7-3.5c1.7-1.6,2.5-3.4,2.6-4.5C267.7,132.1,267.3,131.8,266.7,131.9z"
        />
      </g>
    ),
    [ELF]: (
      <g id={ELF}>
        <g>
          <path
            fill={colors.darkRed}
            d="M82.5,258.2H82c-9.5,0-17.3-7.8-17.3-17.3v0c0-9.5,7.8-17.3,17.3-17.3h0.4c9.5,0,17.3,7.8,17.3,17.3v0
        C99.8,250.4,92,258.2,82.5,258.2z"
          />
          <path
            fill={colors.darkRed}
            d="M131.7,165.2l109.4-17.7c0,0,4.7-27-5.7-39.5c-22.8-0.1-93.3,9.2-104.8,22.1
        C133.2,131.4,131.7,165.2,131.7,165.2z"
          />
          <path
            fill={colors.green}
            d="M229.1,105.6c-11-15.4-17.4-22.1-28.5-34.5s-21.3-31.5-33.7-32.8c-12.4-1.3-40.3,2.2-56.8,13.3
        S72.7,80.5,71.5,94.6s7.2,32.3,12.1,41.6c4.9,9.3,16.4,42.1,15.5,59s-7.4,27.7-7.4,27.7l3.7,2.6c0,0,29.4-26.8,31.2-49.4
        c1.8-22.6,1.1-46.9,1.1-46.9S168.3,105.7,229.1,105.6z"
          />
          <path
            fill={colors.midRed}
            d="M229.7,114.9c-6.3-1.8-14.2-0.3-20.7,0.3c-6.9,0.6-13.8,1.6-20.7,2.7c-13.4,2.3-28.3,5-40.2,12
        c-3.5,2-1,6.6,2.6,6.1c13.2-1.9,26-6.6,39.2-8.9c6.7-1.2,13.4-2,20.1-2.6c6.3-0.5,13.7,0.3,19.8-1.6
        C233.5,121.8,233.7,116.1,229.7,114.9z"
          />
          <g>
            <path
              d="M244.7,129.9c-0.2-5-1.3-9.4-2.7-12.8c-1.4-3.4-3-5.8-4.3-7.4c-1.1-1.3-1.8-2-2.2-2.1c-0.1-0.5-2.5-1.3-6.5-2.1
          c-0.9-1.3-2.3-3.1-4-5.4c-1.7-2.3-3.7-5-5.9-8.3c-2.2-3.3-4.8-7-7.7-11c-5.7-8-12.5-17.3-19.8-27.2c-1.8-2.5-3.7-5-5.6-7.5
          c-1-1.3-1.9-2.5-3-3.9c-1.1-1.4-2.4-2.8-4-4c-1.6-1.3-3.5-2.2-5.3-2.9c-1.8-0.7-3.7-1.1-5.5-1.4c-3.7-0.6-7.1-0.5-10.5-0.5
          c-6.9,0.2-13.7,1.3-20.2,3c-6.5,1.8-12.7,4.2-18.4,7c-11.4,5.7-20.8,13.2-27.9,20.3C84,70.9,79,77.5,75.8,82.4
          c-3.2,4.9-4.6,7.9-4.3,8.1c0.4,0.3,2.5-2.3,6.3-6.5c3.8-4.3,9.3-10.3,16.6-16.6c7.3-6.3,16.6-12.9,27.5-17.8
          c5.4-2.5,11.3-4.5,17.3-5.9c6-1.4,12.3-2.3,18.6-2.4c3.1,0,6.3,0,9.1,0.5c2.8,0.5,5.3,1.3,7.1,2.8c1.9,1.5,3.6,3.9,5.6,6.4
          c1,1.3,2,2.6,3,3.9c0,0.6,0.1,1.3,0.1,2c0.1,3-0.1,6.4-0.8,10c-0.3,1.8-0.8,3.6-1.4,5.5c-0.3,0.9-0.6,1.8-1,2.7
          c-0.1,0.2-0.2,0.4-0.3,0.7c0,0.1,0,0,0,0c0,0,0,0-0.1,0l0,0c0,0,0.1,0-0.1,0c-0.2-0.1-0.5-0.2-0.7-0.3l-1.4-0.5
          c-0.9-0.4-1.8-0.7-2.7-1.2c-1.8-0.8-3.4-1.7-5.1-2.6c-3.2-1.8-6.1-3.7-8.4-5.5c-3.1-2.3-5.3-4.3-6.7-5.3
          c-0.2-0.7-0.3-1.2-0.3-1.4c-0.1,0.1-0.2,0.3-0.3,0.5c0,0.1-0.1,0.3-0.1,0.4c-0.3-0.2-0.6-0.3-0.7-0.2c-0.2,0.2,0.1,0.9,0.8,1.9
          c0,0,0,0.1,0,0.1c0.4,1.9,0.9,4.5,1.3,7.7c0.3,3.2,0.5,7,0.2,10.9c-0.2,2-0.4,4-0.8,6.1c-0.2,1-0.4,2.1-0.6,3.1l-0.4,1.4
          c0,0,0,0.1-0.1,0l0,0l-0.6-0.2c-0.5-0.1-1-0.3-1.5-0.5c-1-0.3-2-0.7-3-1c-1.9-0.8-3.8-1.6-5.6-2.5c-3.5-1.8-6.6-4-9-6
          c-2.5-2-4.4-3.9-5.8-5.2c-1.1-1-1.8-1.7-2.2-1.8c0-0.6,0-0.9-0.1-0.9c-0.4-0.1-1.4,4.4-4.3,10.3c-1.4,2.9-3.4,6.2-5.7,9.3
          c-1.2,1.6-2.5,3.1-3.9,4.6c-0.7,0.7-1.4,1.5-2.2,2.1l-0.5,0.5c-0.2,0.1-0.3,0.3-0.4,0.3c-0.1,0.1-0.1,0-0.1,0l0,0l0,0l0,0
          l-0.3-0.3c-0.2-0.3-0.5-0.6-0.7-0.9c-0.4-0.6-0.8-1.3-1.2-2c-0.7-1.4-1.3-2.8-1.8-4.2c-1-2.8-1.6-5.5-2.2-7.9
          c-0.8-3.4-1.6-5.8-2.1-6.9c0.5-0.7,0.6-1.2,0.5-1.3c-0.3-0.2-1.8,1.1-4.1,2.9c-1.1,0.9-2.5,1.9-4,2.9c-1.5,1-3.1,2-4.8,2.9
          c-1.7,0.9-3.4,1.8-5,2.5c-1.6,0.7-3.2,1.4-4.5,1.9c-2.7,1.1-4.5,1.8-4.4,2.5c0.1,0.6,2.2,0.7,5.1,0c1.5-0.3,3.2-0.9,4.9-1.6
          c1.8-0.7,3.6-1.7,5.3-2.7c1.7-1.1,3.4-2.3,4.8-3.5c1.4-1.2,2.7-2.4,3.7-3.6c0.5-0.6,1-1.1,1.3-1.6c0,1.4,0.3,3.5,0.7,6.1
          c0.4,2.4,0.8,5.2,1.8,8.3c0.5,1.5,1.1,3.1,1.9,4.7c0.4,0.8,0.9,1.6,1.4,2.3c0.2,0.4,0.5,0.7,0.8,1.1l0.2,0.3l0.1,0.1l0.2,0.2
          c0.3,0.3,0.6,0.6,1,0.7c0.5,0.2,1,0.2,1.5,0.1c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.5-0.2,0.6-0.3c0.3-0.2,0.6-0.4,0.8-0.6l0.6-0.6
          c0.8-0.7,1.5-1.5,2.2-2.3c1.4-1.6,2.7-3.3,3.9-5c2.3-3.4,4.1-6.9,5.4-10.1c1.5-3.9,2.2-7.2,2.5-9.2c0.2,0.5,0.6,1.1,1.1,1.9
          c1.1,1.6,2.8,3.8,5.3,6.1c2.5,2.3,5.6,4.7,9.3,6.7c1.8,1,3.8,1.9,5.9,2.7c1,0.4,2.1,0.8,3.2,1.1c0.5,0.2,1.1,0.3,1.6,0.5l0.9,0.2
          c0.5,0.1,1,0.2,1.5,0.1c5.8-12.6,3-24.1,1.1-30.4c1,1.2,2.4,2.5,4,3.9c2.3,2,5.2,4.1,8.6,6.1c1.7,0.9,3.4,1.9,5.3,2.7
          c0.9,0.4,1.9,0.8,2.8,1.2l1.4,0.5c0.2,0.1,0.5,0.2,0.7,0.3l1.3,0.4l1.4,0.5c0,0,0.1,0,0.1,0l0-0.1l0.1-0.2l0.1-0.3l0.3-0.7
          l0.6-1.4c0.1-0.2,0.2-0.5,0.3-0.7c0.3-1,0.7-2,1-2.9c0.6-2,1-3.9,1.2-5.9c0.5-3.5,0.5-6.9,0.2-9.8c0.2,0.3,0.4,0.6,0.7,0.9
          c7.5,9.8,14.5,18.8,20.7,26.5c3.1,3.8,5.9,7.3,8.6,10.4c2.6,3.1,5.1,5.7,7.3,7.7c0.6,0.6,1.3,1.1,1.9,1.6
          c-1.5-0.2-3.1-0.4-4.9-0.6c-5.1-0.5-11.1-0.7-17.5-0.5c-6.4,0.3-13.3,1-20.1,2.1c-6.8,1.3-13.5,3-19.6,5c-1.5,0.5-3,1.1-4.5,1.6
          c-0.7,0.3-1.4,0.5-2.2,0.8c-0.7,0.3-1.4,0.6-2.1,0.9c-1.4,0.6-2.7,1.2-3.9,1.7c-1.3,0.6-2.5,1.2-3.6,1.8c-5.1,2.7-9,5.3-11.3,7.4
          c-0.3-1.8-0.7-3.5-1.1-5c-0.8-2.6-1.6-4.7-2.5-6.4c-1.8-3.4-3.5-4.9-4.2-4.5c-1.6,0.9,1.5,8.3,1.4,20.1
          c0.1,5.9-0.5,12.8-1.6,20.3c-0.7,4.9-1.5,9.9-2.6,15c-0.3-1.2-0.6-2.5-1.1-4c-0.9-2.9-2.3-6.1-4-9.4c-0.8-1.7-1.8-3.3-2.7-5
          c-0.5-0.8-1-1.7-1.5-2.5l-0.8-1.3l-1.5-2.5l-1.5-2.5c0,0-0.1-0.1-0.1-0.1l-0.1,0.2l-0.1,0.3l-0.3,0.7l-0.5,1.3
          c-0.6,1.4-1.1,2.8-1.7,4.2c-0.7,1.8-1.4,3.5-2.1,5.2c-1.4,3.3-2.9,6.4-4.3,8.9c-1.3,2.4-2.6,4.3-3.6,5.8c-0.5-2-1-4-1.5-5.9
          c-2.4-8.6-5.7-17-9.1-24.5c-1.7-3.8-3.5-7.4-5.3-10.7c-1.8-3.3-3.4-6.3-4.6-9.2c-1.3-2.8-2.1-5.4-2.7-7.7
          c-0.5-2.3-0.8-4.4-0.8-6.2c-0.1-3.5,0.3-5.6-0.6-6c-0.4-0.2-1,0.1-1.7,1c-0.7,0.9-1.5,2.4-2,4.4c-0.5,2-0.8,4.6-0.6,7.5
          c0.2,2.9,0.9,6.1,2,9.4c1.1,3.3,2.6,6.7,4.2,10.1c1.6,3.4,3.2,6.9,4.8,10.6c3.2,7.4,6.4,15.4,8.9,23.5c2.5,8.1,4.4,16.4,5.3,24.3
          c0.9,7.9,1,15.3,0.4,21.7c-0.6,7.3-1.9,13.1-2.7,16.8c-2.8-1.5-5.9-2.4-9.4-2.4c-11,0-20.2,9.2-20.2,20.2
          c0,11,9.2,20.2,20.2,20.2c11.1,0,19.4-8.8,20.1-19.5c0-0.2,0.1-0.4,0.1-0.7c0-0.3,0-0.5-0.1-0.7c-0.3-4.9-2.3-9.4-5.4-12.9
          c0.2-0.2,0.4-0.3,0.7-0.5c1.4-1.2,3.1-2.6,5-4.4c0.9-0.9,1.8-1.9,2.9-2.9c0.5-0.5,1-1.1,1.5-1.6c0.5-0.6,1-1.2,1.5-1.8
          c4-4.9,8.2-11,11.8-18.1c3.6-7.1,6.6-15,8.9-23.1c0.9-3.2,1.7-6.4,2.4-9.6c5.5,0.3,19.4-1.9,36.5-4.7c11-1.9,23.3-4,35.7-6
          c6.2-1,12.4-2.1,18.4-3.1c3-0.5,6-1,8.9-1.5c1.4-0.2,2.9-0.5,4.3-0.7c0.7-0.1,1.5-0.2,2.2-0.4c1.2-0.2,2.5-0.6,3.4-1.4
          c1-0.8,1.7-1.8,2.1-2.9c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.1-0.5,0.2-0.7c0.1-0.4,0.2-0.8,0.2-1.1c0.1-0.7,0.2-1.4,0.3-2.1
          c0.1-0.7,0.2-1.4,0.2-2C244.7,135,244.8,132.4,244.7,129.9z M82.4,255.4c-8,0-14.6-6.7-14.6-14.6c0-8,6.6-14.6,14.6-14.6
          c8.2,0,14.3,6.7,14.6,14.6C96.7,248.7,90.6,255.4,82.4,255.4z M114.2,195c-2.9,6.9-6.3,13-9.6,18.1c-0.4,0.6-0.8,1.2-1.2,1.8
          c-0.4,0.6-0.8,1.2-1.2,1.7c-0.8,1.1-1.6,2.2-2.3,3.2c-1.5,1.9-2.8,3.6-3.9,5c-0.2,0.2-0.4,0.4-0.6,0.7c-0.6-0.5-1.2-1-1.8-1.4
          c0.3-0.6,0.6-1.2,0.9-1.9c1.6-3.5,3.5-8.8,4.8-15.4c1.3-6.6,1.9-14.5,1.4-22.9c-0.3-5.9-1.2-12.1-2.5-18.2
          c1.4-1.1,3.4-3.2,5.4-6.2c1.7-2.5,3.3-5.6,4.9-9c0.8-1.7,1.5-3.5,2.2-5.3l0.5-1.2l0,0c0,0,0,0,0,0c0,0,0,0,0,0l0.8,1.2
          c0.5,0.8,1,1.7,1.5,2.5c1,1.6,2,3.3,2.9,4.8c1.8,3.2,3.4,6.2,4.5,8.8c1,2.4,1.7,4.6,2.2,6.2c-0.4,1.8-0.8,3.6-1.3,5.4
          C119.7,180.5,117.2,188.2,114.2,195z M196.3,115.3c1.4,3.5,2.9,8.4,3.4,13.5c0.6,5.1,0.4,10.3,0.2,14.2c-0.1,1.6-0.2,3-0.2,4.1
          c-2.3,0.3-4.5,0.7-6.8,1c0.4-1,1-2.6,1.4-4.7c0.4-1.8,0.7-3.9,0.9-6.2c0.2-2.3,0.2-4.8,0.1-7.2c-0.2-2.5-0.5-4.9-1-7.2
          c-0.5-2.3-1.1-4.3-1.8-6.1c-0.8-2.1-1.6-3.6-2.3-4.5c1.5-0.3,2.9-0.5,4.4-0.7C195,112.4,195.6,113.7,196.3,115.3z M164.2,118.4
          c5.9-1.8,12.2-3.5,18.6-4.9c2-0.4,4.1-0.8,6.1-1.2c0.1,1,0.5,2.8,1.1,5.1c0.4,1.7,0.9,3.7,1.3,5.9c0.4,2.2,0.7,4.5,1,6.8
          c0.2,2.3,0.3,4.7,0.3,6.9c0,2.2-0.1,4.3-0.2,6c-0.2,2.3-0.4,4.1-0.4,5.1c-6.6,1.1-13.1,2.2-19.3,3.4c-0.5-0.8-1.1-1.6-1.8-2.7
          c-2.2-3.3-4.8-8-6.8-12.9c-1-2.5-1.8-5-2.5-7.3c-0.3-1.2-0.6-2.4-0.9-3.5c-0.2-1.1-0.4-2.1-0.5-3c-0.1-0.9-0.1-1.8,0-2.5
          C161.6,119.3,162.9,118.8,164.2,118.4z M132.4,161.9c0.7-3.8,1.3-7.6,1.7-11.3c0.9-7.8,1.2-15.3,0.5-21.7
          c1.2-0.3,2.9-0.8,4.8-1.5c-0.3,0.8-0.5,1.7-0.7,2.6c-0.9,4-1.3,9.5-0.4,14.9c0.5,2.7,1.4,5.4,2.6,7.7c1.1,2.1,2.6,3.9,4,5.2
          C139.5,159.3,135.1,160.7,132.4,161.9z M166.8,152.8c-7.4,1.5-14.1,3-19.7,4.5c-0.1-0.1-0.2-0.3-0.4-0.4
          c-1.3-1.4-2.5-3.3-3.4-5.4c-1-2.1-1.6-4.6-2-7.1c-0.7-5-0.4-10.2,0-14c0.2-1.5,0.3-2.8,0.4-3.9c2-0.7,4.2-1.6,6.6-2.5
          c1.2-0.4,2.4-0.9,3.6-1.4c1.3-0.4,2.6-0.9,3.9-1.4c0.7-0.2,1.3-0.5,2-0.7c0,0,0.1,0,0.1,0c-0.1,0.6-0.2,1.2-0.2,1.8
          c0,1.1,0.1,2.3,0.3,3.5c0.2,1.2,0.5,2.4,0.8,3.7c0.6,2.5,1.5,5.2,2.7,7.7c2.2,5.1,5.3,9.8,8,12.9c0.6,0.7,1.2,1.3,1.7,1.8
          C169.7,152.2,168.2,152.5,166.8,152.8z M221.2,144.1c-6.1,0.7-12.3,1.5-18.6,2.4c-0.6,0.1-1.2,0.2-1.8,0.3c0.3-1,0.6-2.2,0.9-3.7
          c0.8-3.9,1.4-9.3,0.9-14.7c-0.4-5.4-2-10.7-4-14.3c-0.7-1.2-1.4-2.3-2-3.1c1.8-0.3,3.6-0.5,5.3-0.7c6.1-0.6,11.9-1.2,16.9-1.3
          c1,0,1.9-0.1,2.8-0.1c0.3,1.1,1,2.9,1.8,5.2c0.7,1.8,1.3,3.9,1.9,6.3c0.6,2.3,1,4.8,1.3,7.4c0.3,2.5,0.4,5.1,0.3,7.5
          c-0.1,2.4-0.3,4.6-0.6,6.5c-0.1,0.7-0.2,1.3-0.3,1.8C224.5,143.8,222.9,144,221.2,144.1z M239.8,129.9c-0.1,2.2-0.4,4.6-0.9,7
          c-0.1,0.6-0.3,1.2-0.4,1.8c-0.1,0.6-0.3,1.2-0.4,1.9c-0.4,1.5-0.4,1.5-0.8,1.7c-0.2,0.1-0.3,0.1-0.6,0.1
          c-0.7,0.1-1.4,0.1-2.1,0.2c-1.4,0.1-2.9,0.3-4.4,0.4c-0.8,0.1-1.5,0.2-2.3,0.3c0.1-0.4,0.3-0.8,0.4-1.3c0.6-1.9,1-4.3,1.3-6.8
          c0.2-2.5,0.3-5.2,0.1-7.9c-0.2-2.7-0.7-5.4-1.4-7.8c-0.7-2.4-1.5-4.7-2.4-6.5c-0.9-1.9-1.8-3.3-2.6-4.2
          c6.6-0.3,11.2-0.4,12.2-0.9c0,0.4,0.4,1.4,0.9,2.7c0.7,1.8,1.7,4.3,2.5,7.6C239.6,121.5,240.1,125.4,239.8,129.9z"
            />
            <path d="M154.1,59.1c-0.1,0-0.2,0-0.2,0.1C154,59.1,154,59.1,154.1,59.1z" />
          </g>
          <path fill={colors.midRed} d="M81.4,229.7c-6.4,0-6.4,9.9,0,9.9C87.7,239.6,87.8,229.7,81.4,229.7z" />
          <path fill={colors.midRed} d="M77.4,242.7c-4.5,0-4.5,6.9,0,6.9C81.8,249.7,81.8,242.7,77.4,242.7z" />
        </g>
      </g>
    ),
    [FART]: (
      <g id={FART}>
        <path
          fill={colors.white}
          d="M326.5,288.8c0.1,0,0.2,0,0.3,0c8.8-1.4,14.5-11.6,10.6-19.8c-3.3-7-11.5-9.5-18.4-7.3
			c-2.2-5.9-6.6-12.4-14.3-14.8c-6.6-2.1-13.5,4.8-14.8,11c-12.6-1.7-22.3,14.3-12.4,24.8c1.4,1.5,2.7,0.1,3,2.1
			c0.2,1.8-0.5,5,0,6.8c0.9,3.2,2.8,6.1,5.4,8.2c4.8,3.8,10.7,2,15.9-0.3c5.4,8.2,15.5,16.6,24.8,9.6
			C334.6,303.1,331.8,294.8,326.5,288.8z"
        />
        <path
          fill={colors.text}
          d="M265.5,280.5c0.7-0.6-3.9-7.2-8.7-13.5c-4.9-6.3-10-12.3-11.4-11.2c-1.4,1.1,3.2,7.7,8.4,13.7
				C258.9,275.6,264.8,281.1,265.5,280.5z"
        />

        <path
          fill={colors.text}
          d="M246.6,249.3c-0.4,0.8,4.9,4.2,10.2,7.4c5.3,3.2,10.7,6.2,11.6,4.7c1-1.5-4.1-5.3-9.7-8.2
				C253,250.4,246.9,248.5,246.6,249.3z"
        />

        <path
          fill={colors.text}
          d="M256.2,247.8c-0.1,0.9,7,3.1,14.3,4.9c7.2,1.8,14.6,3.2,15,1.5c0.4-1.7-6.8-4-14.2-5.4
				C263.9,247.4,256.3,246.9,256.2,247.8z"
        />

        <path
          fill={colors.text}
          d="M281.4,284.1c0.1-0.2-0.6-0.6-1.6-1.4c-1-0.8-2.3-1.9-3.4-3.6c-1.1-1.7-2-3.9-2.1-6.3c-0.1-2.4,0.7-4.9,2.2-6.9
				c1.5-2,3.6-3.6,5.8-4.2c2.2-0.7,4.5-0.5,6.3-0.1c3.8,0.9,5.8,3,6.5,2.4c0.3-0.3,0.2-1.1-0.7-2.3c-0.9-1.1-2.4-2.5-4.8-3.4
				c-2.3-0.9-5.4-1.3-8.5-0.5c-3.2,0.8-6.1,3-7.9,5.8c-1.9,2.8-2.8,6.3-2.4,9.5c0.4,3.2,1.9,5.8,3.5,7.6c1.7,1.8,3.5,2.8,4.8,3.2
				C280.6,284.3,281.4,284.3,281.4,284.1z"
        />

        <path
          fill={colors.text}
          d="M303.5,297.5c-0.4-0.3-2.2,1.9-5.8,3.1c-1.8,0.6-4,0.9-6.2,0.5c-2.2-0.4-4.4-1.5-6.1-3.1c-1.7-1.6-2.9-3.7-3.4-5.7
				c-0.5-2.1-0.4-4.2,0-5.9c0.8-3.5,2.5-5.5,1.9-6.2c-0.3-0.3-1.1-0.1-2.1,0.7c-1,0.8-2.2,2.3-3.1,4.5c-0.8,2.1-1.2,4.9-0.6,7.8
				c0.6,2.9,2.4,5.7,4.7,7.8c2.4,2,5.4,3.3,8.3,3.5c2.9,0.2,5.6-0.6,7.5-1.7c2-1.1,3.3-2.4,4.1-3.5
				C303.5,298.4,303.7,297.6,303.5,297.5z"
        />

        <path
          fill={colors.text}
          d="M317.7,285.6c0,0.2,1,0.5,2.5,1.1c1.6,0.6,3.7,1.6,5.7,3.5c2,1.8,3.6,4.7,3.9,7.9c0.1,1.6-0.1,3.2-0.7,4.7
				c-0.6,1.5-1.6,2.9-2.9,3.9c-1.3,1.1-2.8,1.9-4.4,2.4c-1.6,0.5-3.2,0.7-4.8,0.6c-3.2-0.2-6-1.7-8.1-3.3c-2.1-1.6-3.6-3.4-4.6-4.7
				c-1-1.3-1.7-2-2.1-1.9c-0.4,0.2-0.4,1.2,0.2,3c0.6,1.7,2,4,4.3,6.2c2.3,2.2,5.8,4.2,10,4.6c2.1,0.2,4.3-0.1,6.4-0.7
				c2.1-0.7,4.1-1.8,5.7-3.3c1.7-1.5,3-3.4,3.8-5.6c0.8-2.1,0.9-4.4,0.6-6.5c-0.6-4.2-3.1-7.5-5.7-9.4c-2.6-1.9-5.2-2.6-7-2.8
				C318.7,285.2,317.7,285.4,317.7,285.6z"
        />

        <path
          fill={colors.text}
          d="M309.7,269.8c0.2,0.1,0.9-0.6,2.2-1.8c1.2-1.2,2.9-3.1,5.3-4.7c1.2-0.8,2.5-1.5,4-1.9c1.5-0.4,3.1-0.6,4.8-0.4
				c3.4,0.3,6.8,1.9,8.9,4.6c2.2,2.7,3.2,6.3,2.9,9.5c-0.2,3.2-1.8,6-3.7,7.9c-1.9,1.9-3.9,3-5.3,3.7c-1.5,0.7-2.4,1-2.4,1.5
				c0,0.4,1.1,0.8,3,0.6c1.9-0.2,4.6-1.1,7.1-3.3c1.3-1.1,2.5-2.5,3.5-4.2c1-1.7,1.6-3.7,1.8-5.9c0.4-4.3-0.9-8.9-3.9-12.4
				c-1.5-1.7-3.4-3.1-5.5-4c-2.1-0.9-4.2-1.3-6.3-1.4c-4.2-0.1-8.1,1.6-10.5,3.7c-2.5,2.1-3.9,4.3-4.8,5.8
				C310,268.7,309.6,269.7,309.7,269.8z"
        />

        <path
          fill={colors.text}
          d="M289.5,259.8c0.5,0,0.6-2.9,2.8-6.1c1.1-1.6,2.7-3.2,4.6-4.3c2-1.1,4.4-1.5,6.8-1.3c2.4,0.2,4.7,1.1,6.4,2.4
				c1.7,1.3,3,3.1,4.1,4.7c1.1,1.7,1.8,2.9,2,3.8c0.3,0.9,0.2,1.5,0.6,1.8c0.2,0.1,0.5,0.1,0.8-0.2c0.3-0.3,0.7-0.8,0.8-1.6
				c0.3-1.5-0.2-3.6-1.2-5.5c-0.9-2-2.3-4.3-4.7-6.2c-2.3-1.9-5.4-3-8.6-3.2c-3.1-0.2-6.4,0.7-8.8,2.4c-2.5,1.7-4.1,3.9-5,6
				c-0.9,2.1-1.2,4-1.2,5.3C289,259.1,289.3,259.8,289.5,259.8z"
        />
      </g>
    ),
    [T_SHIRT]: (
      <g id={T_SHIRT}>
        <path
          d="M185.3,332.8c22.2,1,51.8,1.9,67.4,0.5c8.2-0.7,29.4-2.9,48.7-6.7c27.4-5.4,33-10.8,34.9-15.7c3.7-9.5-1.7-15.9-5.1-19.3
			c1.8-4.4,2.1-8.1,1.6-11.1c7-1.7,17.1-4.7,24.9-9.1c2.3-1.3,3.6-3.8,3.3-6.4c-4.9-43.5-24.3-110.7-27.5-112.7
			c-0.5-0.3-7.5,2.2-8.2,2.5c-56.1,16.6-107,24-151.3,22c-30.9-1.4-52.5-7.3-65.2-11.9c-13.8-5-20.3-9.8-20.4-9.9
			c-1.1-0.8-2.3-1.2-3.6-1.3c-0.8,0-1.7,0.1-2.5,0.4c-2,0.7-3.6,2.4-4.2,4.5C67.7,197.8,50,261.7,47.1,268.8
			c-0.4,0.7-0.8,1.5-0.9,2.4c-0.3,1.9,0.2,3.8,1.4,5.3c6.6,7.8,17.7,13.7,33.1,17.4c1.3,0.3,2.6,0.6,3.9,0.9
			c-4.5,3.9-10.9,10.7-8,18c3.9,9.8,18.8,13,46.6,15.9C133.6,329.8,158.8,331.6,185.3,332.8z"
        />
        <path
          fill={colors.gatsbyDefault}
          d="M327,161.4c4.9-7.5,20.2,61.4,27.3,104.7c-12.2,6.9-31,10.1-31,10.1s6.6,5.3-0.1,16.8
			c0.5,2.5,10.3,6.7,6.8,15.9c-3.5,9.2-50.6,15.8-78.1,18.2s-107.1-2.4-128.2-4.6c-21.1-2.2-37.2-5.5-41.2-11.9
			c-3.2-5.1,9.2-14.4,6.7-17.7c-5.5-7.4-31-8.7-36.7-20.4c1.9-1.2,31.9-112,31.9-112C178.1,212,325.8,163.3,327,161.4z"
        />
        <path
          d="M78.3,177c0.1-0.1,1,0.3,2.7,1.1c0.9,0.4,1.9,0.9,3.2,1.5c1.3,0.5,2.8,1.1,4.4,1.8c6.6,2.7,16.3,5.8,28.2,8.5
					c11.9,2.7,26,5,41.2,6.6c15.2,1.5,31.5,2.3,47.7,2c16.3-0.4,32.5-1.4,47.7-3.4c7.6-0.9,14.8-2.1,21.7-3.4
					c3.4-0.7,6.8-1.3,9.9-2.1c3.2-0.7,6.3-1.5,9.2-2.3c11.8-3.1,21.2-6.8,27.8-9.5c1.6-0.7,3.1-1.3,4.4-1.8c1.3-0.6,2.3-1,3.2-1.4
					c1.8-0.7,2.8-1.1,2.9-0.9c0.1,0.2-0.7,0.8-2.3,1.9c-0.8,0.5-1.8,1.2-3,1.9c-1.2,0.7-2.7,1.4-4.2,2.3
					c-6.4,3.2-15.9,7.3-27.8,10.8c-3,0.9-6.1,1.8-9.3,2.5c-3.2,0.8-6.6,1.6-10,2.3c-6.9,1.4-14.3,2.7-21.9,3.7
					c-15.3,2-31.7,3.1-48.1,3.4c-16.4,0.2-32.8-0.8-48.1-2.6c-15.3-1.8-29.4-4.4-41.4-7.5c-11.9-3-21.6-6.6-28.1-9.7
					c-1.6-0.8-3.1-1.5-4.3-2.1c-1.2-0.7-2.2-1.3-3.1-1.8C79.1,177.6,78.2,177.1,78.3,177z"
        />
        <path
          d="M83,159c0.1-0.1,1,0.3,2.6,1.2c1.6,0.9,3.9,2.3,7,3.7c6.1,3.1,15.1,7,26.4,10c5.6,1.6,11.9,2.9,18.5,4
						c6.6,1,13.7,1.8,21,2.4c7.3,0.5,14.9,0.7,22.6,0.7c7.7,0,15.5-0.3,23.3-0.7c7.8-0.4,15.6-1,23.3-1.7c7.7-0.8,15.2-1.6,22.5-2.7
						c14.5-2,28-4.6,39.5-7.1c22.9-5.1,37.9-10,38.2-9.1c0.9,0.4-3.2,2-10,4.2c-6.5,2.3-15.9,5.2-27.4,8c-11.5,2.8-25,5.6-39.7,7.7
						c-7.3,1.1-14.9,1.9-22.6,2.7c-7.7,0.7-15.6,1.3-23.5,1.7c-7.9,0.3-15.8,0.6-23.5,0.5c-7.8-0.1-15.4-0.4-22.8-1
						c-7.4-0.7-14.5-1.6-21.2-2.8c-6.7-1.3-13-2.7-18.6-4.5C107,172.8,98,168.5,92.1,165c-3-1.7-5.3-3.2-6.8-4.3
						C83.8,159.7,83,159.1,83,159z"
        />
        <path d="M364.3,259.8" />
        <path d="M323.5,160.9" />
        <path
          d="M322,283.7c-0.5-0.3,1.5-4.6,3.9-11.3c1.2-3.3,2.4-7.3,3.5-11.6c1.1-4.3,2-8.9,2.8-13.5c0.7-4.6,1.3-9.3,1.7-13.7
						c0.3-4.4,0.6-8.5,0.7-12c0.2-7,0.2-11.8,1.3-11.9c1-0.1,2.4,4.6,3,11.9c0.3,3.6,0.3,7.9,0,12.5c-0.3,4.6-0.9,9.4-1.8,14.2
						c-1,4.8-2.2,9.5-3.6,13.8c-1.5,4.3-3,8.3-4.7,11.6C325.4,280.1,322.4,284,322,283.7z"
        />
        <path
          d="M291.9,308.2c0-0.6,3.3-1.3,8.1-2.7c4.8-1.4,11.1-3.7,16.2-7.5c2.6-1.9,4.8-4.1,6.5-6.4c1.7-2.3,2.9-4.7,3.6-6.9
						c0.7-2.2,1-4,1-5.3c0.1-1.3,0-2,0.4-2.4c0.2-0.2,0.5-0.2,1,0.1c0.4,0.3,0.9,0.9,1.2,1.7c0.7,1.6,1,4.1,0.5,6.9
						c-0.5,2.8-1.7,5.9-3.7,8.8c-1,1.4-2.2,2.8-3.5,4.1c-1.3,1.2-2.7,2.4-4.3,3.4c-3,2.1-6.3,3.6-9.5,4.6c-3.2,1-6.2,1.6-8.8,1.9
						C295.4,309,291.9,308.7,291.9,308.2z"
        />
        <path
          d="M50.4,272.8c0-0.1,0.6,0.2,1.5,0.8c1,0.5,2.3,1.5,4.1,2.5c3.5,2.1,8.7,4.8,15.2,7.3c6.5,2.5,14.5,3.5,23.1,4.6
						c8.6,0.9,18,0.8,27.1-0.9c2.3-0.4,4.5-0.8,5.3-2.2c0.4-0.7,0.6-1.7,0.8-2.8c0.2-1.1,0.3-2.3,0.5-3.4c0.6-4.6,1.1-9.1,1.6-13.4
						c0.9-8.7,1.5-16.9,1.8-23.9c0.7-14,0.7-23.4,1.4-23.4c0.6,0,1.4,9.4,1.1,23.5c-0.2,7.1-0.6,15.3-1.5,24.1
						c-0.4,4.4-1,8.9-1.6,13.5c-0.2,1.2-0.3,2.3-0.5,3.5c-0.2,1.2-0.4,2.5-1.2,3.9c-0.4,0.7-1,1.3-1.6,1.7c-0.6,0.4-1.3,0.7-1.9,0.9
						c-1.3,0.4-2.5,0.6-3.6,0.8c-9.4,1.7-19.1,1.7-27.9,0.6c-8.8-1.2-16.9-2.6-23.5-5.3c-6.6-2.8-11.7-5.1-15.1-8.2
						c-1.7-1.1-3-2.2-3.9-2.9C50.7,273.2,50.3,272.8,50.4,272.8z"
        />
        <path d="M297.5,187.8c-1.2,0.3-6.8-14.6-4.4-15.2S298.6,187.4,297.5,187.8z" />
        <path d="M291.7,191.2c-1.2,0.4-8-17-5.6-17.8C288.5,172.7,292.9,190.9,291.7,191.2z" />
        <path d="M314.8,182.6c-1.2,0.4-8-17-5.6-17.8C311.6,164.1,316,182.2,314.8,182.6z" />
        <path d="M258.9,196.7c-1.2,0.2-5.8-17.8-3.3-18.2C258,178,260.2,196.4,258.9,196.7z" />
        <path d="M253.8,197c-0.6,0.2-2.2-3.8-3-7.9c-0.8-4.1-0.7-8.4,0.5-8.4c1.2,0,1.8,4,2.3,8C254,192.8,254.4,196.9,253.8,197z" />
        <path d="M214.1,198.4c-1.2,0.1-3.9-14.9-1.4-15.1C215.2,183.1,215.4,198.3,214.1,198.4z" />
        <path d="M208.7,199.4c-1.2,0.1-4.2-15.4-1.7-15.7C209.5,183.5,210,199.3,208.7,199.4z" />
        <path d="M170.2,199.6c-1.2-0.1-1.2-15.2,1.3-15C174,184.8,171.4,199.7,170.2,199.6z" />
        <path d="M166.5,199.4c-1.2-0.1-1.9-15.8,0.5-15.7C169.5,183.8,167.7,199.4,166.5,199.4z" />
        <path d="M132.7,194.7c-1.2-0.3,1.3-14.3,3.6-13.7C138.7,181.7,133.9,195,132.7,194.7z" />
        <path d="M127.7,194.5c-0.6-0.1-0.3-4.1,0.6-7.9c0.9-3.8,2.4-7.4,3.6-7c1.2,0.4,0.3,4.2-0.9,7.8C129.7,191,128.3,194.6,127.7,194.5z" />
        <path d="M94.3,183.5c-1.1-0.5,3.9-14.6,6.2-13.6C102.7,171,95.4,184.1,94.3,183.5z" />
        <path d="M58.3,267c-0.3-0.1,0.8-5.1,2.9-12.6c2-7.5,5-17.4,8.3-27.2c6.5-19.7,14.5-38.8,15.6-38.4c1.2,0.5-6.2,19.8-13,39.3c-3.4,9.7-6.8,19.5-9.3,26.9C60.3,262.2,58.6,267.1,58.3,267z" />
        <path
          d="M149.3,257.5c0.1,0,0.5,0.4,1.1,1.2c0.7,0.8,1.6,2.1,2.9,3.6c2.5,3.1,6.3,7.3,11.6,11.6c5.2,4.3,11.9,8.6,19.6,12.1
						c3.8,1.8,7.9,3.2,12.2,4.6c4.2,1.2,8.6,2.2,13.1,2.9c4.4,0.6,8.9,1,13.4,1.1c4.4,0.1,8.8-0.1,13-0.5c8.4-0.8,16.2-2.3,22.7-4.1
						c6.5-1.7,11.9-3.6,15.6-4.9c3.7-1.3,5.9-2.1,6-1.8c0.1,0.3-1.8,1.5-5.5,3.2c-3.6,1.7-8.9,3.9-15.5,5.9
						c-6.6,2-14.5,3.7-23.1,4.5c-4.3,0.4-8.8,0.6-13.3,0.5c-4.5-0.1-9.1-0.5-13.7-1.2c-4.6-0.8-9.1-1.8-13.4-3.2
						c-4.3-1.4-8.5-3-12.4-4.9c-7.8-3.7-14.5-8.4-19.7-12.9c-5.2-4.6-8.9-9-11.2-12.3c-1.2-1.6-2-3-2.5-3.9
						C149.5,258,149.3,257.5,149.3,257.5z"
        />
        <path
          d="M113.6,310.8c0.1-0.3,5.7,0.5,14.1,1.3c4.2,0.5,9.1,0.8,14.4,1.2c5.3,0.3,10.9,0.5,16.6,0.6c5.6,0.1,11.3,0,16.6-0.2
						c5.3-0.2,10.2-0.5,14.4-0.8c8.4-0.6,14.1-1.1,14.2-0.4c0.1,0.6-5.5,1.9-14,2.9c-4.2,0.5-9.2,0.9-14.5,1.2
						c-5.3,0.2-11,0.3-16.7,0.1c-5.7-0.2-11.4-0.5-16.7-1c-5.3-0.5-10.3-1.2-14.5-1.9c-2.1-0.3-4-0.7-5.7-1
						c-1.7-0.3-3.2-0.6-4.4-0.9C114.9,311.4,113.5,311,113.6,310.8z"
        />
        <path
          d="M258.4,301.8c-0.1-0.4,4.4-2,10.6-5.5c3.1-1.7,6.5-4.1,10.1-6.7c3.5-2.7,6.9-6,10.1-9.4c3.1-3.5,6-7.2,8.4-10.9
						c2.3-3.7,4.4-7.3,5.8-10.5c3-6.4,4.3-11,5-10.8c0.5,0.1-0.1,5-2.8,11.8c-1.3,3.4-3.3,7.2-5.7,11.1c-2.5,3.8-5.5,7.7-8.8,11.3
						c-3.4,3.5-7.1,6.7-10.7,9.4c-3.7,2.6-7.4,4.8-10.7,6.4c-0.8,0.4-1.6,0.8-2.4,1.1c-0.8,0.3-1.5,0.6-2.2,0.9
						c-0.7,0.3-1.3,0.5-1.9,0.7c-0.6,0.2-1.2,0.4-1.7,0.5C259.6,301.7,258.5,301.9,258.4,301.8z"
        />
        <path d="M90.8,181.6c-1.1-0.5,3.8-14.1,6-13C99.1,169.7,91.9,182.1,90.8,181.6z" />
        <path d="M323.1,177.6c-1.1,0.5-9.3-13-7-14C318.3,162.5,324.2,177,323.1,177.6z" />

        <path
          fill={colors.gatsbyDark}
          d="M51.8,273.2c0.3-0.2,2.9-7.2,4.4-12.1c17.5,9,41.4,16.1,72.1,13.7c0.6,0.6,0.3,10-2.6,11.5
			C120.1,289.1,75.4,293.5,51.8,273.2z"
        />
        <path
          fill={colors.gatsbyDark}
          d="M333.4,262.9c6-0.6,11.5-2.1,19.7-5.8c0.5,3.1,0.9,6.1,1.2,9c-8.3,4.7-19.6,7.7-26,9.1
			C330.7,270.2,332.8,264.6,333.4,262.9z"
        />
        <path
          fill={colors.white}
          d="M215.5,269.5c-5.2-5.7-7.7-13.1-7.4-20.1l27,29.3C227.8,278.1,220.7,275.2,215.5,269.5z M241.6,278.3
				l-32.4-35.5c3.4-12.6,15.3-21.6,28.8-21c9.6,0.4,17.7,5.5,22.5,12.7l-4,3.2c-4.1-6.2-11-10.4-18.7-10.7
				c-10.1-0.5-19,5.6-22.8,14.6l28.5,31.2c7.6-2.2,13.6-8.5,15.8-16.2l-12.4-0.6l0.2-5.2l18.2,0.8C264.5,265,254.4,276,241.6,278.3z
				"
        />
      </g>
    ),
    [BEARD]: (
      <g id={BEARD}>
        <path
          fill={colors.tone[tone].dark}
          d="M329.4,211.2c-2.6,15-11.3,37.7-35.5,42c-28.1,5-37.7-7.9-57.3-13c-0.7,0.9-1.5,1.8-2.3,2.7
			c2.5,15.5-0.3,31.8-8.3,45.6c7.9,5.8,23.8,12.1,53.7,6.8C314.2,289.2,331.4,252.4,329.4,211.2z"
        />
        <path
          fill={colors.tone[tone].dark}
          d="M222,238.2c-28.8-0.4-28.1,22.9-68.8,22c-42.9-1-59.6-55.1-63.6-68.2c-2.4,24.3-2.1,63.2,19.2,85.4
			c30.8,32,76.4,30.8,105.4,8.2c0.1-0.4,0.3-0.9,0.6-1.3C223.2,270.7,225.6,253.6,222,238.2z"
        />

        <path fill={colors.tone[tone].mid} d="M175.9,279.5c-3.8,0-3.8,6,0,6C179.7,285.5,179.7,279.5,175.9,279.5z" />
        <path fill={colors.tone[tone].mid} d="M195.8,262.2c-3.8,0-3.8,6,0,6C199.6,268.2,199.6,262.2,195.8,262.2z" />
        <path fill={colors.tone[tone].mid} d="M197.1,280.8c-2.1,0-2.1,3.3,0,3.3C199.3,284.2,199.3,280.8,197.1,280.8z" />
        <path fill={colors.tone[tone].mid} d="M157.2,272.9c-3.8,0-3.8,6,0,6C161.1,278.8,161.1,272.9,157.2,272.9z" />
        <path fill={colors.tone[tone].mid} d="M246.4,267.6c-3.8,0-3.8,6,0,6C250.2,273.5,250.2,267.6,246.4,267.6z" />
        <path fill={colors.tone[tone].mid} d="M214.4,251.6c-3.8,0-3.8,6,0,6C218.3,257.6,218.3,251.6,214.4,251.6z" />
        <path fill={colors.tone[tone].mid} d="M207.8,274.2c-3.8,0-3.8,6,0,6C211.6,280.2,211.6,274.2,207.8,274.2z" />
        <path fill={colors.tone[tone].mid} d="M143.9,283.5c-3.8,0-3.8,6,0,6C147.8,289.5,147.8,283.5,143.9,283.5z" />
        <path fill={colors.tone[tone].mid} d="M101.4,258.3c-3.8,0-3.8,6,0,6C105.2,264.2,105.2,258.3,101.4,258.3z" />
        <path
          fill={colors.tone[tone].mid}
          d="M109.3,242c-1.1,0-2,0.9-2,2c0,0.4,0,0.9,0,1.3c0,1,0.9,2,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9c0-0.4,0-0.9,0-1.3C111.3,242.9,110.4,241.9,109.3,242z"
        />
        <path fill={colors.tone[tone].mid} d="M94.7,235.6c-3.8,0-3.8,6,0,6C98.5,241.6,98.5,235.6,94.7,235.6z" />
        <path fill={colors.tone[tone].mid} d="M112,266.2c-3.8,0-3.8,6,0,6C115.8,272.2,115.8,266.2,112,266.2z" />
        <path fill={colors.tone[tone].mid} d="M255.7,286.2c-3.8,0-3.8,6,0,6C259.5,292.1,259.5,286.2,255.7,286.2z" />
        <path fill={colors.tone[tone].mid} d="M261,264.9c-3.8,0-3.8,6,0,6C264.8,270.9,264.8,264.9,261,264.9z" />
        <path fill={colors.tone[tone].mid} d="M275.6,286.2c-3.8,0-3.8,6,0,6C279.4,292.1,279.5,286.2,275.6,286.2z" />
        <path fill={colors.tone[tone].mid} d="M291.6,267.6c-3.8,0-3.8,6,0,6C295.4,273.5,295.4,267.6,291.6,267.6z" />
        <path fill={colors.tone[tone].mid} d="M276.9,265c-2,0-2,3,0,3C278.9,268.1,278.9,265,276.9,265z" />
        <path fill={colors.tone[tone].mid} d="M312.9,258.3c-3.8,0-3.8,6,0,6C316.7,264.2,316.7,258.3,312.9,258.3z" />
        <path fill={colors.tone[tone].mid} d="M299.6,278.2c-3.8,0-3.8,6,0,6C303.4,284.2,303.4,278.2,299.6,278.2z" />
        <path fill={colors.tone[tone].mid} d="M315.5,248.9c-3.8,0-3.8,6,0,6C319.4,254.9,319.4,248.9,315.5,248.9z" />
      </g>
    ),
    [FRECKLES]: (
      <g id={FRECKLES}>
        <path fill={colors.text} d="M129.8,262.1c-0.2-8.6-14.2-8.4-14,0.3C116,271,130,270.7,129.8,262.1z" />
        <path fill={colors.text} d="M146.3,267.1c-0.1-6.6-10.9-6.4-10.8,0.2C135.7,273.9,146.5,273.7,146.3,267.1z" />
        <path fill={colors.text} d="M135,277.2c-0.1-7.1-11.7-6.9-11.5,0.2C123.6,284.6,135.2,284.4,135,277.2z" />
      </g>
    ),
    [STUBBLE]: (
      <g id={STUBBLE}>
        <path
          fill={colors.text}
          d="M160,309.3c-0.8-0.4-3.6,3.2-6.2,6.8c-2.5,3.7-4.9,7.4-3.5,8.5c1.4,1.1,4.6-2.4,6.8-6.4C159.5,314.2,160.8,309.7,160,309.3z"
        />
        <path
          fill={colors.text}
          d="M321.7,282.2c-0.5,0.7,2.7,4,5.9,7.1c3.3,3,6.7,5.9,7.9,4.6c1.2-1.2-1.7-4.9-5.4-7.7C326.4,283.4,322.2,281.5,321.7,282.2z"
        />
        <path fill={colors.text} d="M166,281.3c-0.7-1.6-18,4.1-16.5,7.3C151,291.8,166.7,282.9,166,281.3z" />
        <path
          fill={colors.text}
          d="M169.6,283.5c-0.9-0.1-2.4,2.7-3.9,5.3c-1.4,2.6-2.9,5.2-1.5,6.3c0.7,0.5,1.7,0.2,2.6-0.7c1-0.9,1.9-2.4,2.5-4c0.6-1.6,0.9-3.3,0.9-4.6C170.3,284.5,170,283.6,169.6,283.5z"
        />
        <path fill={colors.text} d="M99.9,287.1c-0.8-1.6-16.3,3.8-14.7,6.9C86.7,297.2,100.7,288.7,99.9,287.1z" />
        <path
          fill={colors.text}
          d="M106.2,288.9c-0.6-0.6-4.2,1.7-7.5,4.4c-3.3,2.7-6.2,5.6-5.1,7c1.1,1.3,4.7-1,7.8-4.1C104.4,293.1,106.8,289.5,106.2,288.9z"
        />
        <path fill={colors.text} d="M273.9,305.2c-1.8,0.1-2.9,15.3,0.6,15.1C278,320.1,275.7,305.1,273.9,305.2z" />
        <path
          fill={colors.text}
          d="M282.4,303.3c-0.8,0.3-0.4,4.1,0.3,7.7c0.8,3.6,1.9,7,3.6,6.7c1.7-0.4,1.4-4.2,0.2-7.8C285.3,306.3,283.3,303,282.4,303.3z"
        />
        <path fill={colors.text} d="M194,311.3c-1.7,0.6,0,11.4,3.3,10.3S195.7,310.8,194,311.3z" />
        <path fill={colors.text} d="M253.2,282.7c-1.7,0.6,0,11.4,3.3,10.3C259.8,291.9,254.9,282.2,253.2,282.7z" />
        <path fill={colors.text} d="M284.2,259.3c-0.9,1.5,7.5,8.7,9.2,5.6C295.2,261.9,285.1,257.8,284.2,259.3z" />
        <path fill={colors.text} d="M261.9,283.5c-1.4,1,3,7,5.7,5C270.3,286.5,263.3,282.5,261.9,283.5z" />
      </g>
    ),
  }

  return config[property] ? config[property] : null
}

export const MakerBum: FunctionComponent<IMakerBumProps> = ({ config, sx }) => {
  const tone = getCheckedProperties(config).pop()

  return (
    <Box sx={{ margin: '0 auto', ...sx }}>
      <svg version="1.0" x="0px" y="0px" viewBox="0 0 550 410" width="100%" height="100%">
        <g id="base-shadow">
          <ellipse fill={colors.shadowAccent} cx="202.4" cy="310.2" rx="164.7" ry="16.1" />
        </g>
        <g id="outline">
          <path
            fill={colors.text}
            d="M166.1,319.3c-26.4,0-51.3-10.7-70-30.2c-16.9-17.6-25.3-44.1-25.2-78.8
            c0.1-24.2,4.5-43.9,4.7-44.7l3-13.3l249.2-13.4l5.1,11c19,40.8,20,88.9,2.5,122.5c-11.5,22.1-29.6,35.9-52.3,39.9
            c-8.5,1.5-16.5,2.2-24,2.2c-19.4,0-32.5-5.1-40.8-10.4C202.8,313.9,184.5,319.3,166.1,319.3z"
          />
        </g>
        <g id="tone-mid">
          <path
            fill={colors.tone[tone].mid}
            d="M316.6,157.5l-223.5,12c0,0-16.6,73.2,16,107.1s81.8,30.6,110.4,4c0,0,11.3,22.6,60.5,14
            C329.2,285.9,343.2,214.7,316.6,157.5z"
          />
        </g>
        <g id="tone-dark">
          <path
            fill={colors.tone[tone].dark}
            d="M109.1,276.6c32.6,33.9,81.8,30.6,110.4,4c0,0,11.3,22.6,60.5,14c26.4-4.6,42.7-27.4,48-56.2
            c-13.9,37-38.4,47.3-65.8,45.9c-40.9-2-35.9-30.9-35.9-30.9s-21.9,61.9-93.8,27.9c-51.6-24.5-39.4-111.8-39.4-111.8
            S76.5,242.7,109.1,276.6z"
          />
        </g>
        <g id="tone-light">
          <path
            fill={colors.tone[tone].light}
            d="M93.1,169.5c0,0,118.4,38.6,223.5-12C315.3,157.5,93.1,169.5,93.1,169.5z"
          />
        </g>
        <g id="crease">
          <path
            fill={colors.text}
            d="M243.5,216.8c-0.7-7.8-10-3.7-9.5,2.5c0.4,4.5-0.4,8.6-2.5,12.2c-1.6-4.7-3.7-9.2-6.4-13.4
            c-3.1-4.9-14.1-3.2-10.1,3.2c11.6,18.7,11.5,44.2-0.2,62.9c-3.5,5.4,7,10.9,10.1,6.1c8.9-14.1,12.1-31.2,9.4-47.4
            C240.9,235.9,244.3,226.4,243.5,216.8z"
          />
        </g>
        {getCheckedProperties(config).map((property) => properties(property, tone))}
      </svg>
    </Box>
  )
}
